//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiBaseClass {
  protected getBaseUrl = (defaultUrl: string, baseUrl: string | undefined) => {
    return process.env.REACT_APP_API_BASE_URL || defaultUrl;
  };
}

export class MainAPI extends ApiBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://api-develop.apdated.co", baseUrl);
    }

    /**
     * Login to user account
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginRequestModel | undefined): Promise<TokenResponseModel> {
        let url_ = this.baseUrl + "/accounts/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<TokenResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponseModel>(null as any);
    }

    /**
     * Gets user session list
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserSessions(pageSize: number | undefined, pageNumber: number | undefined, userId: string | undefined): Promise<UserSessionResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/accounts?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserSessions(_response);
        });
    }

    protected processGetUserSessions(response: Response): Promise<UserSessionResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSessionResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSessionResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Deactivate all user sessions
     * @return Success
     */
    deactivateAllUserSessions(): Promise<string> {
        let url_ = this.baseUrl + "/accounts/session/deactivate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivateAllUserSessions(_response);
        });
    }

    protected processDeactivateAllUserSessions(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Deactivate user session
     * @return Success
     */
    deactivateUserSession(sessionId: number): Promise<string> {
        let url_ = this.baseUrl + "/accounts/session/{sessionId}/deactivate";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivateUserSession(_response);
        });
    }

    protected processDeactivateUserSession(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Login to user account with 2FA
     * @param body (optional) 
     * @return Success
     */
    loginTwoFA(body: TwoFARequestModel | undefined): Promise<TokenResponseModel> {
        let url_ = this.baseUrl + "/accounts/login-twofa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLoginTwoFA(_response);
        });
    }

    protected processLoginTwoFA(response: Response): Promise<TokenResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponseModel>(null as any);
    }

    /**
     * Reset user password
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accounts/password/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Refresh access token
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenRequestModel | undefined): Promise<TokenResponseModel> {
        let url_ = this.baseUrl + "/accounts/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: Response): Promise<TokenResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponseModel>(null as any);
    }

    /**
     * Logout
     * @return No Content
     */
    logout(): Promise<void> {
        let url_ = this.baseUrl + "/accounts/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Registration user account
     * @param body (optional) 
     * @return Success
     */
    registration(body: RegistrationRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accounts/sign-up";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistration(_response);
        });
    }

    protected processRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Confirm registration
     * @param body (optional) 
     * @return Success
     */
    confirmRegistration(body: ActivateAccountRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accounts/sign-up/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmRegistration(_response);
        });
    }

    protected processConfirmRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Send confirmation again
     * @param body (optional) 
     * @return Success
     */
    sendRegistrationConfirmationAgain(body: SendConfirmationRegistrationRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accounts/sign-up/confirm/link/send-again";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRegistrationConfirmationAgain(_response);
        });
    }

    protected processSendRegistrationConfirmationAgain(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Forgot password
     * @param body (optional) 
     * @return No Content
     */
    forgotPassword(body: ForgotPasswordRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accounts/password/forgot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Restore password
     * @param body (optional) 
     * @return No Content
     */
    restorePassword(body: RestorePasswordRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accounts/password/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestorePassword(_response);
        });
    }

    protected processRestorePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Check on valid the restore password link
     * @return Success
     */
    isValidRestorePasswordLink(userId: string, code: string): Promise<boolean> {
        let url_ = this.baseUrl + "/accounts/password/restore/link/is-valid?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsValidRestorePasswordLink(_response);
        });
    }

    protected processIsValidRestorePasswordLink(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get last agreement by agreement type
     * @return Success
     */
    getLastAgreementByType(typeId: AgreementTypeEnum): Promise<AgreementResponseModel> {
        let url_ = this.baseUrl + "/agreements/last-agreement-by-type/{typeId}";
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined.");
        url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastAgreementByType(_response);
        });
    }

    protected processGetLastAgreementByType(response: Response): Promise<AgreementResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgreementResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgreementResponseModel>(null as any);
    }

    /**
     * Is signed by user Id by type Id
     * @return Success
     */
    isSignedByUserIdAndTypeId(typeId: AgreementTypeEnum): Promise<boolean> {
        let url_ = this.baseUrl + "/agreements/is-signed-by-user-and-type/{typeId}";
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined.");
        url_ = url_.replace("{typeId}", encodeURIComponent("" + typeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsSignedByUserIdAndTypeId(_response);
        });
    }

    protected processIsSignedByUserIdAndTypeId(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Sign agreement by user
     * @param body (optional) 
     * @return Success
     */
    signAgreementByUserId(body: AgreementRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/agreements/sign-agreement-by-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignAgreementByUserId(_response);
        });
    }

    protected processSignAgreementByUserId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create a new attachment and return s3key and URL
     * @param body (optional) 
     * @return Success
     */
    createAttachment(body: AttachmentCreateRequestModel | undefined): Promise<AttachmentResponseModel> {
        let url_ = this.baseUrl + "/attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAttachment(_response);
        });
    }

    protected processCreateAttachment(response: Response): Promise<AttachmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentResponseModel>(null as any);
    }

    /**
     * Get URL to attachment
     * @return Success
     */
    getAttachmentUrl(attachmentId: string): Promise<AttachmentResponseModel> {
        let url_ = this.baseUrl + "/attachments/{attachmentId}/get-url";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttachmentUrl(_response);
        });
    }

    protected processGetAttachmentUrl(response: Response): Promise<AttachmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentResponseModel>(null as any);
    }

    /**
     * Get cancellation reasons
     * @return Success
     */
    getCancellationReasons(): Promise<CancellationReasonResponseModel[]> {
        let url_ = this.baseUrl + "/cancellation-reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCancellationReasons(_response);
        });
    }

    protected processGetCancellationReasons(response: Response): Promise<CancellationReasonResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancellationReasonResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancellationReasonResponseModel[]>(null as any);
    }

    /**
     * Get user cancellation reasons list
     * @param sortOrder (optional) 
     * @param searchTerm (optional) 
     * @param reasons (optional) 
     * @param planTypes (optional) 
     * @param requestedDateTo (optional) 
     * @param requestedDateFrom (optional) 
     * @param actualCancelDateTo (optional) 
     * @param actualCancelDateFrom (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getUserCancellationReasons(sortOrder: SortOrderEnum | undefined, searchTerm: string | undefined, reasons: number[] | undefined, planTypes: number[] | undefined, requestedDateTo: Date | undefined, requestedDateFrom: Date | undefined, actualCancelDateTo: Date | undefined, actualCancelDateFrom: Date | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<UserCancellationReasonResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/cancellation-reason?";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (reasons === null)
            throw new Error("The parameter 'reasons' cannot be null.");
        else if (reasons !== undefined)
            reasons && reasons.forEach(item => { url_ += "Reasons=" + encodeURIComponent("" + item) + "&"; });
        if (planTypes === null)
            throw new Error("The parameter 'planTypes' cannot be null.");
        else if (planTypes !== undefined)
            planTypes && planTypes.forEach(item => { url_ += "PlanTypes=" + encodeURIComponent("" + item) + "&"; });
        if (requestedDateTo === null)
            throw new Error("The parameter 'requestedDateTo' cannot be null.");
        else if (requestedDateTo !== undefined)
            url_ += "RequestedDateTo=" + encodeURIComponent(requestedDateTo ? "" + requestedDateTo.toISOString() : "") + "&";
        if (requestedDateFrom === null)
            throw new Error("The parameter 'requestedDateFrom' cannot be null.");
        else if (requestedDateFrom !== undefined)
            url_ += "RequestedDateFrom=" + encodeURIComponent(requestedDateFrom ? "" + requestedDateFrom.toISOString() : "") + "&";
        if (actualCancelDateTo === null)
            throw new Error("The parameter 'actualCancelDateTo' cannot be null.");
        else if (actualCancelDateTo !== undefined)
            url_ += "ActualCancelDateTo=" + encodeURIComponent(actualCancelDateTo ? "" + actualCancelDateTo.toISOString() : "") + "&";
        if (actualCancelDateFrom === null)
            throw new Error("The parameter 'actualCancelDateFrom' cannot be null.");
        else if (actualCancelDateFrom !== undefined)
            url_ += "ActualCancelDateFrom=" + encodeURIComponent(actualCancelDateFrom ? "" + actualCancelDateFrom.toISOString() : "") + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserCancellationReasons(_response);
        });
    }

    protected processGetUserCancellationReasons(response: Response): Promise<UserCancellationReasonResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserCancellationReasonResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCancellationReasonResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Sets a card as primary
     * @param userId (optional) 
     * @param paymentMethodId (optional) 
     * @return Success
     */
    setPrimary(userId: string | undefined, paymentMethodId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/cards?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' cannot be null.");
        else if (paymentMethodId !== undefined)
            url_ += "paymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPrimary(_response);
        });
    }

    protected processSetPrimary(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get user cards
     * @param userId (optional) 
     * @return Success
     */
    getCards(userId: string | undefined): Promise<PaymentMethodResponseModel[]> {
        let url_ = this.baseUrl + "/cards?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCards(_response);
        });
    }

    protected processGetCards(response: Response): Promise<PaymentMethodResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentMethodResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodResponseModel[]>(null as any);
    }

    /**
     * Delete user card
     * @param paymentMethodId (optional) 
     * @return Success
     */
    deletePaymentMethod(paymentMethodId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/cards?";
        if (paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' cannot be null.");
        else if (paymentMethodId !== undefined)
            url_ += "paymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePaymentMethod(_response);
        });
    }

    protected processDeletePaymentMethod(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates new payment intent
     * @param userId (optional) 
     * @return Success
     */
    createPaymentIntent(userId: string | undefined): Promise<PaymentIntentResponseModel> {
        let url_ = this.baseUrl + "/cards/payment-intent?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePaymentIntent(_response);
        });
    }

    protected processCreatePaymentIntent(response: Response): Promise<PaymentIntentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentIntentResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentIntentResponseModel>(null as any);
    }

    /**
     * Checks whether user card was atthached earlier
     * @param tokenId (optional) 
     * @return Success
     */
    wasCardAlreadyAttached(tokenId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/cards/was-attached?";
        if (tokenId === null)
            throw new Error("The parameter 'tokenId' cannot be null.");
        else if (tokenId !== undefined)
            url_ += "tokenId=" + encodeURIComponent("" + tokenId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWasCardAlreadyAttached(_response);
        });
    }

    protected processWasCardAlreadyAttached(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Overview dashboard.
     * @param pageSize (optional) 
     * @return Success
     */
    getOverviewDashboard(pageSize: number | undefined): Promise<FolderDashboardResponseModelOverviewDashboardResponseModel> {
        let url_ = this.baseUrl + "/dashboards/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "pageSize": pageSize !== undefined && pageSize !== null ? "" + pageSize : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOverviewDashboard(_response);
        });
    }

    protected processGetOverviewDashboard(response: Response): Promise<FolderDashboardResponseModelOverviewDashboardResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderDashboardResponseModelOverviewDashboardResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderDashboardResponseModelOverviewDashboardResponseModel>(null as any);
    }

    /**
     * Project overview dashboard.
     * @param pageSize (optional) 
     * @return Success
     */
    getProjectOverviewDashboard(folderId: string, pageSize: number | undefined): Promise<TrackerDashboardResponseModelOverviewDashboardResponseModel> {
        let url_ = this.baseUrl + "/dashboards/project-overview/{folderId}";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "pageSize": pageSize !== undefined && pageSize !== null ? "" + pageSize : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProjectOverviewDashboard(_response);
        });
    }

    protected processGetProjectOverviewDashboard(response: Response): Promise<TrackerDashboardResponseModelOverviewDashboardResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrackerDashboardResponseModelOverviewDashboardResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrackerDashboardResponseModelOverviewDashboardResponseModel>(null as any);
    }

    /**
     * Get countries
     * @return Success
     */
    getCountries(): Promise<CountryModel[]> {
        let url_ = this.baseUrl + "/dictionaries/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<CountryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryModel[]>(null as any);
    }

    /**
     * Update email ignore settings
     * @param body (optional) 
     * @return Success
     */
    updateEmailIgnoreSettings(body: EmailIgnoreOptionsRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/email-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmailIgnoreSettings(_response);
        });
    }

    protected processUpdateEmailIgnoreSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create new folder
     * @param body (optional) 
     * @return Success
     */
    createFolder(body: FolderRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFolder(_response);
        });
    }

    protected processCreateFolder(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update folder
     * @param body (optional) 
     * @return Success
     */
    updateFolder(body: FolderUpdateRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFolder(_response);
        });
    }

    protected processUpdateFolder(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Add visibility restriction by user and folder
     * @return Success
     */
    addVisibilityRestriction(folderId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/folders/{folderId}/users/{userId}/restrictions";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddVisibilityRestriction(_response);
        });
    }

    protected processAddVisibilityRestriction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove visibility restriction by user and folder
     * @return Success
     */
    removeVisibilityRestriction(folderId: string, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/folders/{folderId}/users/{userId}/restrictions";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveVisibilityRestriction(_response);
        });
    }

    protected processRemoveVisibilityRestriction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Change visibility restriction by user group, user and folder
     * @param isVisible (optional) 
     * @return Success
     */
    changeVisibilityRestrictionByUserGroupIdAndUserId(folderId: string, userGroupId: string, userId: string, isVisible: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/folders/{folderId}/user-groups/{userGroupId}/users/{userId}/restrictions?";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (isVisible === null)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else if (isVisible !== undefined)
            url_ += "isVisible=" + encodeURIComponent("" + isVisible) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeVisibilityRestrictionByUserGroupIdAndUserId(_response);
        });
    }

    protected processChangeVisibilityRestrictionByUserGroupIdAndUserId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get user permission for folder
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getUsersPermissionForFolder(pageSize: number | undefined, pageNumber: number | undefined, folderId: string): Promise<FolderVisibilityPermissionResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/folders/{folderId}/paged/users/permissions?";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsersPermissionForFolder(_response);
        });
    }

    protected processGetUsersPermissionForFolder(response: Response): Promise<FolderVisibilityPermissionResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderVisibilityPermissionResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderVisibilityPermissionResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get folders by user
     * @param completenessFilter (optional) 
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getFoldersByUserPaged(completenessFilter: CompletenessFilterEnum | undefined, sortField: SortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined, spaceId: string): Promise<FolderResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/folders/paged/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (completenessFilter === null)
            throw new Error("The parameter 'completenessFilter' cannot be null.");
        else if (completenessFilter !== undefined)
            url_ += "CompletenessFilter=" + encodeURIComponent("" + completenessFilter) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoldersByUserPaged(_response);
        });
    }

    protected processGetFoldersByUserPaged(response: Response): Promise<FolderResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get folders by user
     * @return Success
     */
    getFoldersByUser(spaceId: string): Promise<FolderResponseModel[]> {
        let url_ = this.baseUrl + "/folders/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoldersByUser(_response);
        });
    }

    protected processGetFoldersByUser(response: Response): Promise<FolderResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderResponseModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderResponseModel[]>(null as any);
    }

    /**
     * Get folders by space
     * @return Success
     */
    getFoldersBySpace(spaceId: string): Promise<FolderResponseModel[]> {
        let url_ = this.baseUrl + "/folders/{spaceId}/list";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoldersBySpace(_response);
        });
    }

    protected processGetFoldersBySpace(response: Response): Promise<FolderResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderResponseModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderResponseModel[]>(null as any);
    }

    /**
     * Get folders by user without templates
     * @return Success
     */
    getFoldersByUserWithoutTemplates(spaceId: string): Promise<FolderResponseModel[]> {
        let url_ = this.baseUrl + "/folders/without-templates/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoldersByUserWithoutTemplates(_response);
        });
    }

    protected processGetFoldersByUserWithoutTemplates(response: Response): Promise<FolderResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderResponseModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderResponseModel[]>(null as any);
    }

    /**
     * Check on available creation projects
     * @return Success
     */
    checkFoldersRestriction(spaceId: string): Promise<RestrictionResponseModel> {
        let url_ = this.baseUrl + "/folders/subscription/check/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckFoldersRestriction(_response);
        });
    }

    protected processCheckFoldersRestriction(response: Response): Promise<RestrictionResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RestrictionResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestrictionResponseModel>(null as any);
    }

    /**
     * Get folder list
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getFolderList(sortField: FolderSortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<FolderListResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/folders?";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFolderList(_response);
        });
    }

    protected processGetFolderList(response: Response): Promise<FolderListResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderListResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderListResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get progress tracker details
     * @return Success
     */
    getProgressTrackerBySearch(progressTrackerId: string): Promise<ProgressTrackerResponseModel> {
        let url_ = this.baseUrl + "/guest/progress-trackers/{progressTrackerId}/info";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerBySearch(_response);
        });
    }

    protected processGetProgressTrackerBySearch(response: Response): Promise<ProgressTrackerResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerResponseModel>(null as any);
    }

    /**
     * Subscribe on progress tracker
     * @param body (optional) 
     * @return Success
     */
    subscribeOnProgressTracker(body: SubscribeProgressTrackerRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/guest/progress-trackers/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscribeOnProgressTracker(_response);
        });
    }

    protected processSubscribeOnProgressTracker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Unsubscribe on progress tracker
     * @return Success
     */
    unsubscribeOnProgressTracker(subscriptionId: string): Promise<void> {
        let url_ = this.baseUrl + "/guest/progress-trackers/unsubscribe/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnsubscribeOnProgressTracker(_response);
        });
    }

    protected processUnsubscribeOnProgressTracker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Let`s get you apdated form
     * @param body (optional) 
     * @return Success
     */
    sendLetsGetYouApdatedForm(body: LetsGetYouApdatedRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/landing-pages/contact-us";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendLetsGetYouApdatedForm(_response);
        });
    }

    protected processSendLetsGetYouApdatedForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update twilio sms status via webhook from twilio
     * @param messageSid (optional) 
     * @param messageStatus (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param optOutType (optional) 
     * @param optInType (optional) 
     * @return Success
     */
    updateSmsStatus(messageSid: string | undefined, messageStatus: string | undefined, from: string | undefined, to: string | undefined, optOutType: string | undefined, optInType: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/message-history/webhook-twilio-sms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (messageSid === null || messageSid === undefined)
            throw new Error("The parameter 'messageSid' cannot be null.");
        else
            content_.append("MessageSid", messageSid.toString());
        if (messageStatus === null || messageStatus === undefined)
            throw new Error("The parameter 'messageStatus' cannot be null.");
        else
            content_.append("MessageStatus", messageStatus.toString());
        if (from === null || from === undefined)
            throw new Error("The parameter 'from' cannot be null.");
        else
            content_.append("From", from.toString());
        if (to === null || to === undefined)
            throw new Error("The parameter 'to' cannot be null.");
        else
            content_.append("To", to.toString());
        if (optOutType === null || optOutType === undefined)
            throw new Error("The parameter 'optOutType' cannot be null.");
        else
            content_.append("OptOutType", optOutType.toString());
        if (optInType === null || optInType === undefined)
            throw new Error("The parameter 'optInType' cannot be null.");
        else
            content_.append("OptInType", optInType.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSmsStatus(_response);
        });
    }

    protected processUpdateSmsStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update email status via webhook from aws sns
     * @return Success
     */
    updateEmailStatus(): Promise<void> {
        let url_ = this.baseUrl + "/message-history/webhook-aws-email";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmailStatus(_response);
        });
    }

    protected processUpdateEmailStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get messages by spaceId(if user is owner) or userId
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param messageStatus (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param messageSubjects (optional) 
     * @param projectId (optional) 
     * @param email (optional) 
     * @param messageType (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getMessagesBySpaceOrUserId(spaceId: string, sortField: MessageHistorySortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, messageStatus: MessageStatusEnum | undefined, from: Date | undefined, to: Date | undefined, messageSubjects: number[] | undefined, projectId: string | undefined, email: string | undefined, messageType: MessageTypeEnum | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<AnalyticsMessageHistoryResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/message-history/space/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (messageStatus === null)
            throw new Error("The parameter 'messageStatus' cannot be null.");
        else if (messageStatus !== undefined)
            url_ += "MessageStatus=" + encodeURIComponent("" + messageStatus) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (messageSubjects === null)
            throw new Error("The parameter 'messageSubjects' cannot be null.");
        else if (messageSubjects !== undefined)
            messageSubjects && messageSubjects.forEach(item => { url_ += "MessageSubjects=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (messageType === null)
            throw new Error("The parameter 'messageType' cannot be null.");
        else if (messageType !== undefined)
            url_ += "MessageType=" + encodeURIComponent("" + messageType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessagesBySpaceOrUserId(_response);
        });
    }

    protected processGetMessagesBySpaceOrUserId(response: Response): Promise<AnalyticsMessageHistoryResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnalyticsMessageHistoryResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnalyticsMessageHistoryResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Export messages by spaceId(if user is owner) or userId in Excel file
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param messageStatus (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param messageSubjects (optional) 
     * @param projectId (optional) 
     * @param email (optional) 
     * @param messageType (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @param timezone (optional) 
     * @return Success
     */
    exportMessagesToExcel(spaceId: string, sortField: MessageHistorySortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, messageStatus: MessageStatusEnum | undefined, from: Date | undefined, to: Date | undefined, messageSubjects: number[] | undefined, projectId: string | undefined, email: string | undefined, messageType: MessageTypeEnum | undefined, pageSize: number | undefined, pageNumber: number | undefined, timezone: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/message-history/spaces/{spaceId}/export?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (messageStatus === null)
            throw new Error("The parameter 'messageStatus' cannot be null.");
        else if (messageStatus !== undefined)
            url_ += "MessageStatus=" + encodeURIComponent("" + messageStatus) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (messageSubjects === null)
            throw new Error("The parameter 'messageSubjects' cannot be null.");
        else if (messageSubjects !== undefined)
            messageSubjects && messageSubjects.forEach(item => { url_ += "MessageSubjects=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (messageType === null)
            throw new Error("The parameter 'messageType' cannot be null.");
        else if (messageType !== undefined)
            url_ += "MessageType=" + encodeURIComponent("" + messageType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (timezone === null)
            throw new Error("The parameter 'timezone' cannot be null.");
        else if (timezone !== undefined)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportMessagesToExcel(_response);
        });
    }

    protected processExportMessagesToExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get messages by admin
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param messageStatus (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param messageSubjects (optional) 
     * @param projectId (optional) 
     * @param email (optional) 
     * @param messageType (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getMessages(sortField: MessageHistorySortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, messageStatus: MessageStatusEnum | undefined, from: Date | undefined, to: Date | undefined, messageSubjects: number[] | undefined, projectId: string | undefined, email: string | undefined, messageType: MessageTypeEnum | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<MessageHistoryResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/message-history?";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (messageStatus === null)
            throw new Error("The parameter 'messageStatus' cannot be null.");
        else if (messageStatus !== undefined)
            url_ += "MessageStatus=" + encodeURIComponent("" + messageStatus) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (messageSubjects === null)
            throw new Error("The parameter 'messageSubjects' cannot be null.");
        else if (messageSubjects !== undefined)
            messageSubjects && messageSubjects.forEach(item => { url_ += "MessageSubjects=" + encodeURIComponent("" + item) + "&"; });
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (messageType === null)
            throw new Error("The parameter 'messageType' cannot be null.");
        else if (messageType !== undefined)
            url_ += "MessageType=" + encodeURIComponent("" + messageType) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMessages(_response);
        });
    }

    protected processGetMessages(response: Response): Promise<MessageHistoryResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageHistoryResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageHistoryResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get unread notification total count
     * @return Success
     */
    getUnreadNotificationsCount(): Promise<number> {
        let url_ = this.baseUrl + "/notifications/unread-total-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnreadNotificationsCount(_response);
        });
    }

    protected processGetUnreadNotificationsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get list of notifications
     * @param pageSize (optional) 
     * @param notificationId (optional) 
     * @return Success
     */
    getNotifications(pageSize: number | undefined, notificationId: number | undefined): Promise<NotificationResponseModel[]> {
        let url_ = this.baseUrl + "/notifications?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: Response): Promise<NotificationResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationResponseModel[]>(null as any);
    }

    /**
     * Delete notifications
     * @return No Content
     */
    deleteNotifications(): Promise<void> {
        let url_ = this.baseUrl + "/notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNotifications(_response);
        });
    }

    protected processDeleteNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set status for notification by id
     * @return No Content
     */
    setNotificationStatus(notificationId: number, isNew: boolean): Promise<void> {
        let url_ = this.baseUrl + "/notifications/{notificationId}/is-new/{isNew}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        if (isNew === undefined || isNew === null)
            throw new Error("The parameter 'isNew' must be defined.");
        url_ = url_.replace("{isNew}", encodeURIComponent("" + isNew));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetNotificationStatus(_response);
        });
    }

    protected processSetNotificationStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set status for notifications
     * @return No Content
     */
    readAllNotification(): Promise<void> {
        let url_ = this.baseUrl + "/notifications/read-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReadAllNotification(_response);
        });
    }

    protected processReadAllNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete notification by id
     * @return No Content
     */
    deleteNotificationById(notificationId: number): Promise<void> {
        let url_ = this.baseUrl + "/notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNotificationById(_response);
        });
    }

    protected processDeleteNotificationById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update onboarding status
     * @param body (optional) 
     * @return Success
     */
    updateOnboardingStatus(body: EditOnboardingRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/onboarding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOnboardingStatus(_response);
        });
    }

    protected processUpdateOnboardingStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get payment list
     * @param userId (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param desc (optional) 
     * @return Success
     */
    getPayments(userId: string | undefined, page: string | undefined, limit: number | undefined, desc: boolean | undefined): Promise<PaymentHistoryResponseModelStripePagedList> {
        let url_ = this.baseUrl + "/payments?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (desc === null)
            throw new Error("The parameter 'desc' cannot be null.");
        else if (desc !== undefined)
            url_ += "desc=" + encodeURIComponent("" + desc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayments(_response);
        });
    }

    protected processGetPayments(response: Response): Promise<PaymentHistoryResponseModelStripePagedList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentHistoryResponseModelStripePagedList;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentHistoryResponseModelStripePagedList>(null as any);
    }

    /**
     * Export Payments in Excel file
     * @param userId (optional) 
     * @param timezone (optional) 
     * @return Success
     */
    exportPaymentsExcel(userId: string | undefined, timezone: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/payments/export?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (timezone === null)
            throw new Error("The parameter 'timezone' cannot be null.");
        else if (timezone !== undefined)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportPaymentsExcel(_response);
        });
    }

    protected processExportPaymentsExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get payment list
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getPaymentsByAdmin(pageSize: number | undefined, pageNumber: string | undefined): Promise<AdminPaymentHistoryResponseModelStripePagedList> {
        let url_ = this.baseUrl + "/admin/payments?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaymentsByAdmin(_response);
        });
    }

    protected processGetPaymentsByAdmin(response: Response): Promise<AdminPaymentHistoryResponseModelStripePagedList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminPaymentHistoryResponseModelStripePagedList;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminPaymentHistoryResponseModelStripePagedList>(null as any);
    }

    /**
     * Export Payments in Excel file
     * @return Success
     */
    exportPaymentsExcelByAdmin(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/admin/payments/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportPaymentsExcelByAdmin(_response);
        });
    }

    protected processExportPaymentsExcelByAdmin(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Create progress tracker
     * @param body (optional) 
     * @return Success
     */
    createProgressTracker(body: ProgressTrackerRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/progress-trackers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateProgressTracker(_response);
        });
    }

    protected processCreateProgressTracker(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get progress trackers by spacename
     * @param completenessFilter (optional) 
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getProgressTrackersBySpace(completenessFilter: CompletenessFilterEnum | undefined, sortField: SortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<ProgressTrackerCardResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers?";
        if (completenessFilter === null)
            throw new Error("The parameter 'completenessFilter' cannot be null.");
        else if (completenessFilter !== undefined)
            url_ += "CompletenessFilter=" + encodeURIComponent("" + completenessFilter) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackersBySpace(_response);
        });
    }

    protected processGetProgressTrackersBySpace(response: Response): Promise<ProgressTrackerCardResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerCardResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerCardResponseModel>(null as any);
    }

    /**
     * Update progress tracker
     * @param body (optional) 
     * @return Success
     */
    updateProgressTracker(body: ProgressTrackerEditRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/progress-trackers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProgressTracker(_response);
        });
    }

    protected processUpdateProgressTracker(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Create progress tracker list by template file on S3
     * @param body (optional) 
     * @param spaceId (optional) 
     * @param file (optional) 
     * @return Success
     */
    createProgressTrackerListByS3TemplateFile(body: Body | undefined, spaceId: string | undefined, file: FileParameter | undefined): Promise<ProgressTrackerCreateFromFileResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/list/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (spaceId === null || spaceId === undefined)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else
            content_.append("SpaceId", spaceId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateProgressTrackerListByS3TemplateFile(_response);
        });
    }

    protected processCreateProgressTrackerListByS3TemplateFile(response: Response): Promise<ProgressTrackerCreateFromFileResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerCreateFromFileResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerCreateFromFileResponseModel>(null as any);
    }

    /**
     * Get progress tracker details
     * @return Success
     */
    getProgressTrackerDetails(progressTrackerId: string): Promise<ProgressTrackerResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/info";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerDetails(_response);
        });
    }

    protected processGetProgressTrackerDetails(response: Response): Promise<ProgressTrackerResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerResponseModel>(null as any);
    }

    /**
     * Get progress tracker comments
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getProgressTrackerComments(progressTrackerId: string, pageSize: number | undefined, pageNumber: number | undefined): Promise<ProgressTrackerCommentResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/comments?";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerComments(_response);
        });
    }

    protected processGetProgressTrackerComments(response: Response): Promise<ProgressTrackerCommentResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerCommentResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerCommentResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Adds comment to progress tracker
     * @param body (optional) 
     * @return Success
     */
    addCommentToProgressTracker(progressTrackerId: string, body: CreateCommentRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/comments";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCommentToProgressTracker(_response);
        });
    }

    protected processAddCommentToProgressTracker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Progress tracker details mobile
     * @return Success
     */
    getDetailsMobile(progressTrackerId: string): Promise<ProgressTrackerMobileResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/mobile/{progressTrackerId}/info";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDetailsMobile(_response);
        });
    }

    protected processGetDetailsMobile(response: Response): Promise<ProgressTrackerMobileResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerMobileResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerMobileResponseModel>(null as any);
    }

    /**
     * Get progress tracker list
     * @param completenessFilter (optional) 
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getProgressTrackerList(folderId: string, completenessFilter: CompletenessFilterEnum | undefined, sortField: SortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<ProgressTrackerCardResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/{folderId}/folder?";
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        if (completenessFilter === null)
            throw new Error("The parameter 'completenessFilter' cannot be null.");
        else if (completenessFilter !== undefined)
            url_ += "CompletenessFilter=" + encodeURIComponent("" + completenessFilter) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerList(_response);
        });
    }

    protected processGetProgressTrackerList(response: Response): Promise<ProgressTrackerCardResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerCardResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerCardResponseModel>(null as any);
    }

    /**
     * Get tracker history
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getProgressTrackerHistory(progressTrackerId: string, sortField: ProgressTrackerHistorySortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<ProgressTrackerHistoryResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/history?";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerHistory(_response);
        });
    }

    protected processGetProgressTrackerHistory(response: Response): Promise<ProgressTrackerHistoryResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerHistoryResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerHistoryResponseModelPagedResponseModel>(null as any);
    }

    /**
     * search trackers globally by name
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    searchByName(name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<ProgressTrackerSearchResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/mobile/search?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchByName(_response);
        });
    }

    protected processSearchByName(response: Response): Promise<ProgressTrackerSearchResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerSearchResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerSearchResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Create progress tracker list based template
     * @param body (optional) 
     * @return Success
     */
    createProgressTrackerList(body: ProgressTrackerListRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/progress-trackers/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateProgressTrackerList(_response);
        });
    }

    protected processCreateProgressTrackerList(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Move progress tracker to another folder
     * @param body (optional) 
     * @return Success
     */
    moveProgressTrackerToFolder(progressTrackerId: string, body: MoveProgressTrackerToFolderRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/move-to-folder";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveProgressTrackerToFolder(_response);
        });
    }

    protected processMoveProgressTrackerToFolder(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get deleted progress trackers
     * @param completenessFilter (optional) 
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getDeletedTrackers(spaceId: string, completenessFilter: CompletenessFilterEnum | undefined, sortField: SortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<ArchivedProgressTrackerCardResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/{spaceId}/deleted?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (completenessFilter === null)
            throw new Error("The parameter 'completenessFilter' cannot be null.");
        else if (completenessFilter !== undefined)
            url_ += "CompletenessFilter=" + encodeURIComponent("" + completenessFilter) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeletedTrackers(_response);
        });
    }

    protected processGetDeletedTrackers(response: Response): Promise<ArchivedProgressTrackerCardResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchivedProgressTrackerCardResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArchivedProgressTrackerCardResponseModel>(null as any);
    }

    /**
     * Restore progress tracker from delete
     * @return Success
     */
    restoreFromDelete(trackerId: string): Promise<string> {
        let url_ = this.baseUrl + "/progress-trackers/{trackerId}/restore";
        if (trackerId === undefined || trackerId === null)
            throw new Error("The parameter 'trackerId' must be defined.");
        url_ = url_.replace("{trackerId}", encodeURIComponent("" + trackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreFromDelete(_response);
        });
    }

    protected processRestoreFromDelete(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Mark progress tracker for delete
     * @return Success
     */
    markForDelete(trackerId: string): Promise<void> {
        let url_ = this.baseUrl + "/progress-trackers/{trackerId}";
        if (trackerId === undefined || trackerId === null)
            throw new Error("The parameter 'trackerId' must be defined.");
        url_ = url_.replace("{trackerId}", encodeURIComponent("" + trackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkForDelete(_response);
        });
    }

    protected processMarkForDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete progress tracker
     * @return Success
     */
    deleteProgressTracker(trackerId: string): Promise<void> {
        let url_ = this.baseUrl + "/progress-trackers/{trackerId}";
        if (trackerId === undefined || trackerId === null)
            throw new Error("The parameter 'trackerId' must be defined.");
        url_ = url_.replace("{trackerId}", encodeURIComponent("" + trackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteProgressTracker(_response);
        });
    }

    protected processDeleteProgressTracker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Check on available creation trackers
     * @return Success
     */
    checkTrackersRestriction(spaceId: string): Promise<RestrictionResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/subscription/check/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckTrackersRestriction(_response);
        });
    }

    protected processCheckTrackersRestriction(response: Response): Promise<RestrictionResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RestrictionResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestrictionResponseModel>(null as any);
    }

    /**
     * Get list sorted by stages deadlines
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getForWidget(pageSize: number | undefined, pageNumber: number | undefined): Promise<WidgetModelPagedResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/mobile/widget?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForWidget(_response);
        });
    }

    protected processGetForWidget(response: Response): Promise<WidgetModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WidgetModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WidgetModelPagedResponseModel>(null as any);
    }

    /**
     * Archive progress tracker
     * @return Success
     */
    archiveProgressTracker(progressTrackerId: string): Promise<string> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/archive";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchiveProgressTracker(_response);
        });
    }

    protected processArchiveProgressTracker(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Unarchive progress tracker
     * @return Success
     */
    unarchiveProgressTracker(progressTrackerId: string): Promise<string> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/unarchive";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnarchiveProgressTracker(_response);
        });
    }

    protected processUnarchiveProgressTracker(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get archived progress tracker list
     * @param completenessFilter (optional) 
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getArchivedTrackerList(spaceId: string, completenessFilter: CompletenessFilterEnum | undefined, sortField: SortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<ArchivedProgressTrackerCardResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/{spaceId}/archived?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (completenessFilter === null)
            throw new Error("The parameter 'completenessFilter' cannot be null.");
        else if (completenessFilter !== undefined)
            url_ += "CompletenessFilter=" + encodeURIComponent("" + completenessFilter) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArchivedTrackerList(_response);
        });
    }

    protected processGetArchivedTrackerList(response: Response): Promise<ArchivedProgressTrackerCardResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArchivedProgressTrackerCardResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArchivedProgressTrackerCardResponseModel>(null as any);
    }

    /**
     * Get progress tracker subscribers list
     * @param spaceId (optional) 
     * @param type (optional) 
     * @param emailPhone (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getProgressTrackerSubscribersList(progressTrackerId: string, spaceId: string | undefined, type: SubscribeTypeEnum | undefined, emailPhone: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<ProgressTrackerSubscriberResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/subscribers?";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "SpaceId=" + encodeURIComponent("" + spaceId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (emailPhone === null)
            throw new Error("The parameter 'emailPhone' cannot be null.");
        else if (emailPhone !== undefined)
            url_ += "EmailPhone=" + encodeURIComponent("" + emailPhone) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerSubscribersList(_response);
        });
    }

    protected processGetProgressTrackerSubscribersList(response: Response): Promise<ProgressTrackerSubscriberResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerSubscriberResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerSubscriberResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Export trackers in Excel file
     * @param timezone (optional) 
     * @return Success
     */
    exportTrackersExcel(spaceId: string, timezone: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/progress-trackers/export/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (timezone === null)
            throw new Error("The parameter 'timezone' cannot be null.");
        else if (timezone !== undefined)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportTrackersExcel(_response);
        });
    }

    protected processExportTrackersExcel(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get user who allowed sms messaging
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     */
    getUsersWhoAllowedSmsMessaging(spaceId: string, progressTrackerId: string, pageSize: number | undefined, pageNumber: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/progress-trackers/{progressTrackerId}/allowed-sms/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsersWhoAllowedSmsMessaging(_response);
        });
    }

    protected processGetUsersWhoAllowedSmsMessaging(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get tracker list
     * @param name (optional) 
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getAdminProgressTrackerList(name: string | undefined, sortField: ProgressTrackerSortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<AdminProgressTrackerResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/progress-trackers?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdminProgressTrackerList(_response);
        });
    }

    protected processGetAdminProgressTrackerList(response: Response): Promise<AdminProgressTrackerResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminProgressTrackerResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminProgressTrackerResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get progress tracker comments
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getAdminProgressTrackerComments(progressTrackerId: string, pageSize: number | undefined, pageNumber: number | undefined): Promise<ProgressTrackerCommentResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/progress-trackers/{progressTrackerId}/comments?";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdminProgressTrackerComments(_response);
        });
    }

    protected processGetAdminProgressTrackerComments(response: Response): Promise<ProgressTrackerCommentResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerCommentResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerCommentResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get progress tracker details
     * @return Success
     */
    getProgressTrackerDetailsByAdmin(progressTrackerId: string): Promise<AdminProgressTrackerDetailedResponseModel> {
        let url_ = this.baseUrl + "/admin/progress-trackers/{progressTrackerId}";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerDetailsByAdmin(_response);
        });
    }

    protected processGetProgressTrackerDetailsByAdmin(response: Response): Promise<AdminProgressTrackerDetailedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminProgressTrackerDetailedResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminProgressTrackerDetailedResponseModel>(null as any);
    }

    /**
     * Get tracker history
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getAdminProgressTrackerHistory(progressTrackerId: string, sortField: ProgressTrackerHistorySortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<AdminProgressTrackerHistoryResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/progress-trackers/{progressTrackerId}/history?";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdminProgressTrackerHistory(_response);
        });
    }

    protected processGetAdminProgressTrackerHistory(response: Response): Promise<AdminProgressTrackerHistoryResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminProgressTrackerHistoryResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminProgressTrackerHistoryResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get progress tracker subscribers list by admin
     * @param type (optional) 
     * @param emailPhone (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getAdminProgressTrackerSubscribersList(progressTrackerId: string, type: SubscribeTypeEnum | undefined, emailPhone: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<ProgressTrackerSubscriberResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/progress-trackers/{progressTrackerId}/subscribers?";
        if (progressTrackerId === undefined || progressTrackerId === null)
            throw new Error("The parameter 'progressTrackerId' must be defined.");
        url_ = url_.replace("{progressTrackerId}", encodeURIComponent("" + progressTrackerId));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (emailPhone === null)
            throw new Error("The parameter 'emailPhone' cannot be null.");
        else if (emailPhone !== undefined)
            url_ += "EmailPhone=" + encodeURIComponent("" + emailPhone) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdminProgressTrackerSubscribersList(_response);
        });
    }

    protected processGetAdminProgressTrackerSubscribersList(response: Response): Promise<ProgressTrackerSubscriberResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerSubscriberResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerSubscriberResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Create progress tracker template
     * @param body (optional) 
     * @return Success
     */
    createProgressTrackerTemplate(body: ProgressTrackerTemplateRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/progress-tracker-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateProgressTrackerTemplate(_response);
        });
    }

    protected processCreateProgressTrackerTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update progress tracker template
     * @param body (optional) 
     * @return Success
     */
    updateProgressTrackerTemplate(body: ProgressTrackerTemplateEditRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/progress-tracker-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProgressTrackerTemplate(_response);
        });
    }

    protected processUpdateProgressTrackerTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get progress tracker template list
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param isDraft (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getProgressTrackerTemplates(sortField: SortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, name: string | undefined, isDraft: boolean | undefined, pageSize: number | undefined, pageNumber: number | undefined, spaceId: string): Promise<ProgressTrackerTemplateCardResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/progress-tracker-templates/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isDraft === null)
            throw new Error("The parameter 'isDraft' cannot be null.");
        else if (isDraft !== undefined)
            url_ += "IsDraft=" + encodeURIComponent("" + isDraft) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerTemplates(_response);
        });
    }

    protected processGetProgressTrackerTemplates(response: Response): Promise<ProgressTrackerTemplateCardResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerTemplateCardResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerTemplateCardResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get details for pre-setup progress tracker template
     * @return Success
     */
    getPreSetupProgressTrackerTemplateDetails(progressTrackerTemplateId: string): Promise<PreSetupPTTemplateDetailsResponseModel> {
        let url_ = this.baseUrl + "/progress-tracker-templates/pre-setup/{progressTrackerTemplateId}/info";
        if (progressTrackerTemplateId === undefined || progressTrackerTemplateId === null)
            throw new Error("The parameter 'progressTrackerTemplateId' must be defined.");
        url_ = url_.replace("{progressTrackerTemplateId}", encodeURIComponent("" + progressTrackerTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreSetupProgressTrackerTemplateDetails(_response);
        });
    }

    protected processGetPreSetupProgressTrackerTemplateDetails(response: Response): Promise<PreSetupPTTemplateDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreSetupPTTemplateDetailsResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSetupPTTemplateDetailsResponseModel>(null as any);
    }

    /**
     * Get progress tracker pre-setup template list
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param categories (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getPreSetupTemplates(sortOrder: SortOrderEnum | undefined, name: string | undefined, categories: number[] | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<PreSetupPTTemplateCardResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/progress-tracker-templates/pre-setup?";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (categories === null)
            throw new Error("The parameter 'categories' cannot be null.");
        else if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreSetupTemplates(_response);
        });
    }

    protected processGetPreSetupTemplates(response: Response): Promise<PreSetupPTTemplateCardResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreSetupPTTemplateCardResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSetupPTTemplateCardResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get details progress tracker template
     * @return Success
     */
    getProgressTrackerTemplateDetails(progressTrackerTemplateId: string): Promise<ProgressTrackerTemplateResponseModel> {
        let url_ = this.baseUrl + "/progress-tracker-templates/{progressTrackerTemplateId}/info";
        if (progressTrackerTemplateId === undefined || progressTrackerTemplateId === null)
            throw new Error("The parameter 'progressTrackerTemplateId' must be defined.");
        url_ = url_.replace("{progressTrackerTemplateId}", encodeURIComponent("" + progressTrackerTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProgressTrackerTemplateDetails(_response);
        });
    }

    protected processGetProgressTrackerTemplateDetails(response: Response): Promise<ProgressTrackerTemplateResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProgressTrackerTemplateResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressTrackerTemplateResponseModel>(null as any);
    }

    /**
     * Check on reusable template
     * @return Success
     */
    isReusableTemplateAvailable(spaceId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/progress-tracker-templates/is-reusable-available/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsReusableTemplateAvailable(_response);
        });
    }

    protected processIsReusableTemplateAvailable(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Delete progress tracker template
     * @return Success
     */
    deleteProgressTrackerTemplate(progressTrackerTemplateId: string): Promise<void> {
        let url_ = this.baseUrl + "/progress-tracker-templates/{progressTrackerTemplateId}";
        if (progressTrackerTemplateId === undefined || progressTrackerTemplateId === null)
            throw new Error("The parameter 'progressTrackerTemplateId' must be defined.");
        url_ = url_.replace("{progressTrackerTemplateId}", encodeURIComponent("" + progressTrackerTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteProgressTrackerTemplate(_response);
        });
    }

    protected processDeleteProgressTrackerTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create space
     * @param body (optional) 
     * @return Success
     */
    createSpace(body: SpaceRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/spaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSpace(_response);
        });
    }

    protected processCreateSpace(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get spaces
     * @return Success
     */
    getSpacesByUser(): Promise<SpaceResponseModel[]> {
        let url_ = this.baseUrl + "/spaces";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpacesByUser(_response);
        });
    }

    protected processGetSpacesByUser(response: Response): Promise<SpaceResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaceResponseModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceResponseModel[]>(null as any);
    }

    /**
     * Make user as owner
     * @param body (optional) 
     * @return Success
     */
    makeAsUserOwner(body: EditOwnershipRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/spaces/make-owner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMakeAsUserOwner(_response);
        });
    }

    protected processMakeAsUserOwner(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get active users in space
     * @param spaceId (optional) 
     * @return Success
     */
    getActiveUsersInSpace(spaceId: string | undefined): Promise<ActiveUserResponseModel[]> {
        let url_ = this.baseUrl + "/spaces/get-active-users?";
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveUsersInSpace(_response);
        });
    }

    protected processGetActiveUsersInSpace(response: Response): Promise<ActiveUserResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActiveUserResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActiveUserResponseModel[]>(null as any);
    }

    /**
     * Get users in space
     * @param spaceId (optional) 
     * @return Success
     */
    getUsersInSpace(spaceId: string | undefined): Promise<ActiveUserResponseModel[]> {
        let url_ = this.baseUrl + "/spaces/get-users?";
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsersInSpace(_response);
        });
    }

    protected processGetUsersInSpace(response: Response): Promise<ActiveUserResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActiveUserResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActiveUserResponseModel[]>(null as any);
    }

    /**
     * Can a user create or update a subdomain for space
     * @return Success
     */
    canCreateOrUpdateSubdomain(spaceId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/spaces/{spaceId}/can-create-update-subdomain";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCanCreateOrUpdateSubdomain(_response);
        });
    }

    protected processCanCreateOrUpdateSubdomain(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Add subdomain to space
     * @param body (optional) 
     * @return Success
     */
    addSubdomainToSpace(body: SpaceSubdomainRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/spaces/subdomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddSubdomainToSpace(_response);
        });
    }

    protected processAddSubdomainToSpace(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update user space role
     * @param body (optional) 
     * @return Success
     */
    updateUserSpaceRole(body: EditUserSpaceRoleRequestModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/spaces/user-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserSpaceRole(_response);
        });
    }

    protected processUpdateUserSpaceRole(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get space last activity
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getSpaceLastActivity(pageSize: number | undefined, pageNumber: number | undefined, spaceId: string): Promise<SpaceLastActivityResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/spaces/{spaceId}/analytics/last-activity?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpaceLastActivity(_response);
        });
    }

    protected processGetSpaceLastActivity(response: Response): Promise<SpaceLastActivityResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaceLastActivityResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceLastActivityResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get detailed space counters analytics
     * @return Success
     */
    getSpaceCountersAnalytics(spaceId: string): Promise<SpaceAnalyticsResponseModel> {
        let url_ = this.baseUrl + "/spaces/{spaceId}/analytics/counters";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpaceCountersAnalytics(_response);
        });
    }

    protected processGetSpaceCountersAnalytics(response: Response): Promise<SpaceAnalyticsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaceAnalyticsResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceAnalyticsResponseModel>(null as any);
    }

    /**
     * Get detailed space folders analytics
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getSpaceFoldersAnalytics(pageSize: number | undefined, pageNumber: number | undefined, spaceId: string): Promise<SpaceFolderTrackersCountResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/spaces/{spaceId}/analytics/folders?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpaceFoldersAnalytics(_response);
        });
    }

    protected processGetSpaceFoldersAnalytics(response: Response): Promise<SpaceFolderTrackersCountResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaceFolderTrackersCountResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceFolderTrackersCountResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get space list
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getSpaceList(sortField: SpaceSortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<AdminSpaceResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/spaces?";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpaceList(_response);
        });
    }

    protected processGetSpaceList(response: Response): Promise<AdminSpaceResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminSpaceResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminSpaceResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Set stage status
     * @param body (optional) 
     * @return Success
     */
    setStageStatus(stageId: string, body: SetStatusRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/stages/{stageId}/status";
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetStageStatus(_response);
        });
    }

    protected processSetStageStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Set stage status
     * @param body (optional) 
     * @return Success
     */
    setStageStatusByAdmin(stageId: string, body: SetStatusRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/admin/stages/{stageId}/status";
        if (stageId === undefined || stageId === null)
            throw new Error("The parameter 'stageId' must be defined.");
        url_ = url_.replace("{stageId}", encodeURIComponent("" + stageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetStageStatusByAdmin(_response);
        });
    }

    protected processSetStageStatusByAdmin(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param s3Key (optional) 
     * @param fullPath (optional) 
     * @param bucketName (optional) 
     * @param contentType (optional) 
     * @return Success
     */
    storage(s3Key: string | undefined, fullPath: string | undefined, bucketName: string | undefined, contentType: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/storage?";
        if (s3Key === null)
            throw new Error("The parameter 's3Key' cannot be null.");
        else if (s3Key !== undefined)
            url_ += "s3Key=" + encodeURIComponent("" + s3Key) + "&";
        if (fullPath === null)
            throw new Error("The parameter 'fullPath' cannot be null.");
        else if (fullPath !== undefined)
            url_ += "fullPath=" + encodeURIComponent("" + fullPath) + "&";
        if (bucketName === null)
            throw new Error("The parameter 'bucketName' cannot be null.");
        else if (bucketName !== undefined)
            url_ += "bucketName=" + encodeURIComponent("" + bucketName) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStorage(_response);
        });
    }

    protected processStorage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get common file by type
     * @param fileType (optional) 
     * @return Success
     */
    getCommonFile(fileType: FileTypeEnum | undefined): Promise<S3DownloadResponseModel> {
        let url_ = this.baseUrl + "/storage/common-file?";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommonFile(_response);
        });
    }

    protected processGetCommonFile(response: Response): Promise<S3DownloadResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as S3DownloadResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<S3DownloadResponseModel>(null as any);
    }

    /**
     * Get subscriptions
     * @return Success
     */
    getSubscriptions(): Promise<SubscriptionResponseModel[]> {
        let url_ = this.baseUrl + "/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubscriptions(_response);
        });
    }

    protected processGetSubscriptions(response: Response): Promise<SubscriptionResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionResponseModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionResponseModel[]>(null as any);
    }

    /**
     * Create subscriptions
     * @param body (optional) 
     * @return Success
     */
    createSubscription(body: SubscriptionRequestModel | undefined): Promise<PaymentResponseModel> {
        let url_ = this.baseUrl + "/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSubscription(_response);
        });
    }

    protected processCreateSubscription(response: Response): Promise<PaymentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentResponseModel>(null as any);
    }

    /**
     * Upgrade or downgrade subscriptions
     * @param body (optional) 
     * @return Success
     */
    updateSubscription(body: SubscriptionRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSubscription(_response);
        });
    }

    protected processUpdateSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update subscriptions after payment
     * @param spaceId (optional) 
     * @param intentType (optional) 
     * @return Success
     */
    confirmSubscription(intentId: string, spaceId: string | undefined, intentType: IntentTypeEnum | undefined): Promise<void> {
        let url_ = this.baseUrl + "/subscriptions/{intentId}/confirm?";
        if (intentId === undefined || intentId === null)
            throw new Error("The parameter 'intentId' must be defined.");
        url_ = url_.replace("{intentId}", encodeURIComponent("" + intentId));
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        if (intentType === null)
            throw new Error("The parameter 'intentType' cannot be null.");
        else if (intentType !== undefined)
            url_ += "intentType=" + encodeURIComponent("" + intentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmSubscription(_response);
        });
    }

    protected processConfirmSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Add invite subscription
     * @param spaceId (optional) 
     * @param inviteQuantity (optional) 
     * @param priceId (optional) 
     * @return Success
     */
    addInvitesSubscription(spaceId: string | undefined, inviteQuantity: number | undefined, priceId: string | undefined): Promise<PaymentResponseModel> {
        let url_ = this.baseUrl + "/subscriptions/add-invite-subscription?";
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        if (inviteQuantity === null)
            throw new Error("The parameter 'inviteQuantity' cannot be null.");
        else if (inviteQuantity !== undefined)
            url_ += "inviteQuantity=" + encodeURIComponent("" + inviteQuantity) + "&";
        if (priceId === null)
            throw new Error("The parameter 'priceId' cannot be null.");
        else if (priceId !== undefined)
            url_ += "priceId=" + encodeURIComponent("" + priceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddInvitesSubscription(_response);
        });
    }

    protected processAddInvitesSubscription(response: Response): Promise<PaymentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentResponseModel>(null as any);
    }

    /**
     * Cancel subscription.
     * @param reasonId (optional) 
     * @return Success
     */
    cancelSubscription(spaceId: string, reasonId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/subscriptions/{spaceId}/cancel?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (reasonId === null)
            throw new Error("The parameter 'reasonId' cannot be null.");
        else if (reasonId !== undefined)
            url_ += "reasonId=" + encodeURIComponent("" + reasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelSubscription(_response);
        });
    }

    protected processCancelSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Webhook for stripe succeeded payment.
     * @return Success
     */
    webhook(): Promise<PaymentResponseModel> {
        let url_ = this.baseUrl + "/subscriptions/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWebhook(_response);
        });
    }

    protected processWebhook(response: Response): Promise<PaymentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentResponseModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentResponseModel>(null as any);
    }

    /**
     * Upgrade to Enterprice Plan
     * @param body (optional) 
     * @return Success
     */
    upgradeToEnterprise(body: UpgradeToEnterpriseRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/subscriptions/upgrade/enterprise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpgradeToEnterprise(_response);
        });
    }

    protected processUpgradeToEnterprise(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get sum description for the upcoming subscription
     * @param priceId (optional) 
     * @param promotionCode (optional) 
     * @param spaceId (optional) 
     * @param defaultPaymentMethod (optional) 
     * @param isUpgradeRequested (optional) 
     * @param isInviteRequested (optional) 
     * @param quantity (optional) 
     * @param requestedBillingCycle (optional) 
     * @return Success
     */
    getSumDescriptionUpcomingSubscription(priceId: string | undefined, promotionCode: string | undefined, spaceId: string | undefined, defaultPaymentMethod: string | undefined, isUpgradeRequested: boolean | undefined, isInviteRequested: boolean | undefined, quantity: number | undefined, requestedBillingCycle: BillingCycleEnum | undefined): Promise<SubscriptionSumDescriptionResponseModel> {
        let url_ = this.baseUrl + "/subscriptions/sum-description?";
        if (priceId === null)
            throw new Error("The parameter 'priceId' cannot be null.");
        else if (priceId !== undefined)
            url_ += "PriceId=" + encodeURIComponent("" + priceId) + "&";
        if (promotionCode === null)
            throw new Error("The parameter 'promotionCode' cannot be null.");
        else if (promotionCode !== undefined)
            url_ += "PromotionCode=" + encodeURIComponent("" + promotionCode) + "&";
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "SpaceId=" + encodeURIComponent("" + spaceId) + "&";
        if (defaultPaymentMethod === null)
            throw new Error("The parameter 'defaultPaymentMethod' cannot be null.");
        else if (defaultPaymentMethod !== undefined)
            url_ += "DefaultPaymentMethod=" + encodeURIComponent("" + defaultPaymentMethod) + "&";
        if (isUpgradeRequested === null)
            throw new Error("The parameter 'isUpgradeRequested' cannot be null.");
        else if (isUpgradeRequested !== undefined)
            url_ += "IsUpgradeRequested=" + encodeURIComponent("" + isUpgradeRequested) + "&";
        if (isInviteRequested === null)
            throw new Error("The parameter 'isInviteRequested' cannot be null.");
        else if (isInviteRequested !== undefined)
            url_ += "IsInviteRequested=" + encodeURIComponent("" + isInviteRequested) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "Quantity=" + encodeURIComponent("" + quantity) + "&";
        if (requestedBillingCycle === null)
            throw new Error("The parameter 'requestedBillingCycle' cannot be null.");
        else if (requestedBillingCycle !== undefined)
            url_ += "RequestedBillingCycle=" + encodeURIComponent("" + requestedBillingCycle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSumDescriptionUpcomingSubscription(_response);
        });
    }

    protected processGetSumDescriptionUpcomingSubscription(response: Response): Promise<SubscriptionSumDescriptionResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionSumDescriptionResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionSumDescriptionResponseModel>(null as any);
    }

    /**
     * Create pre setup template
     * @param body (optional) 
     * @return Success
     */
    createPreSetupTemplate(body: PreSetupTemplateRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/admin/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePreSetupTemplate(_response);
        });
    }

    protected processCreatePreSetupTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update pre setup template
     * @param body (optional) 
     * @return Success
     */
    updatePreSetupTemplate(body: PreSetupTemplateEditRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/admin/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePreSetupTemplate(_response);
        });
    }

    protected processUpdatePreSetupTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Delete pre setup template
     * @param templateId (optional) 
     * @return Success
     */
    deletePreSetupTemplate(templateId: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/admin/templates?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePreSetupTemplate(_response);
        });
    }

    protected processDeletePreSetupTemplate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get progress tracker pre-setup template list by Admin
     * @param sortOrder (optional) 
     * @param name (optional) 
     * @param categories (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getPreSetupTemplatesByAdmin(sortOrder: SortOrderEnum | undefined, name: string | undefined, categories: number[] | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<AdminPreSetupPTTemplateCardResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/templates/pre-setup?";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (categories === null)
            throw new Error("The parameter 'categories' cannot be null.");
        else if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreSetupTemplatesByAdmin(_response);
        });
    }

    protected processGetPreSetupTemplatesByAdmin(response: Response): Promise<AdminPreSetupPTTemplateCardResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminPreSetupPTTemplateCardResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminPreSetupPTTemplateCardResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get details for pre-setup progress tracker template by admin
     * @return Success
     */
    getPreSetupProgressTrackerTemplateDetailsByAdmin(progressTrackerTemplateId: string): Promise<AdminPreSetupPTTemplateDetailsResponseModel> {
        let url_ = this.baseUrl + "/admin/templates/pre-setup/{progressTrackerTemplateId}/info";
        if (progressTrackerTemplateId === undefined || progressTrackerTemplateId === null)
            throw new Error("The parameter 'progressTrackerTemplateId' must be defined.");
        url_ = url_.replace("{progressTrackerTemplateId}", encodeURIComponent("" + progressTrackerTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreSetupProgressTrackerTemplateDetailsByAdmin(_response);
        });
    }

    protected processGetPreSetupProgressTrackerTemplateDetailsByAdmin(response: Response): Promise<AdminPreSetupPTTemplateDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminPreSetupPTTemplateDetailsResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminPreSetupPTTemplateDetailsResponseModel>(null as any);
    }

    /**
     * Subscribe to other user's tracker
     * @param body (optional) 
     * @return Success
     */
    subscribe(body: TrackerSubscribeRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/tracker-subscription/mobile/subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscribe(_response);
        });
    }

    protected processSubscribe(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Unubscribe from other user's tracker
     * @param body (optional) 
     * @return No Content
     */
    unsubscribe(body: TrackerUnsubscribeRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/tracker-subscription/mobile/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnsubscribe(_response);
        });
    }

    protected processUnsubscribe(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get list of trackers user is subscribed to
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getList(pageSize: number | undefined, pageNumber: number | undefined): Promise<SubscribedTrackerResponseModel[]> {
        let url_ = this.baseUrl + "/tracker-subscription/mobile?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: Response): Promise<SubscribedTrackerResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscribedTrackerResponseModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscribedTrackerResponseModel[]>(null as any);
    }

    /**
     * Get user profile
     * @param spaceId (optional) 
     * @return Success
     */
    getUserProfile(spaceId: string | undefined): Promise<UserResponseModel> {
        let url_ = this.baseUrl + "/users/profile?";
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserProfile(_response);
        });
    }

    protected processGetUserProfile(response: Response): Promise<UserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResponseModel>(null as any);
    }

    /**
     * Update user profile
     * @param body (optional) 
     * @return Success
     */
    updateUserProfile(body: UserUpdateRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserProfile(_response);
        });
    }

    protected processUpdateUserProfile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Check is user registered by invite
     * @return Success
     */
    getInfoByInvite(inviteId: string): Promise<InviteUserResponseModel> {
        let url_ = this.baseUrl + "/users/invite/{inviteId}";
        if (inviteId === undefined || inviteId === null)
            throw new Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{inviteId}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInfoByInvite(_response);
        });
    }

    protected processGetInfoByInvite(response: Response): Promise<InviteUserResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InviteUserResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteUserResponseModel>(null as any);
    }

    /**
     * Get users list
     * @param term (optional) 
     * @param sortField (optional) 
     * @param sortOrder (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getUserList(term: string | undefined, sortField: UserSortFieldEnum | undefined, sortOrder: SortOrderEnum | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<UserListResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/users?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserList(_response);
        });
    }

    protected processGetUserList(response: Response): Promise<UserListResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserListResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserListResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get user detailed info
     * @return Success
     */
    getUserInfo(userId: string): Promise<AdminUserInfoResponseModel> {
        let url_ = this.baseUrl + "/admin/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: Response): Promise<AdminUserInfoResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminUserInfoResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminUserInfoResponseModel>(null as any);
    }

    /**
     * Get user comments
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getUserComments(userId: string, pageSize: number | undefined, pageNumber: number | undefined): Promise<UserCommentResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/admin/users/{userId}/comments?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserComments(_response);
        });
    }

    protected processGetUserComments(response: Response): Promise<UserCommentResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserCommentResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCommentResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Adds comment to user
     * @param body (optional) 
     * @return Success
     */
    addCommentToUser(userId: string, body: CreateUserCommentRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/users/{userId}/comments";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCommentToUser(_response);
        });
    }

    protected processAddCommentToUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get attachment by user id
     * @return Success
     */
    getUserAttachment(): Promise<AttachmentResponseModel> {
        let url_ = this.baseUrl + "/user-attachment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserAttachment(_response);
        });
    }

    protected processGetUserAttachment(response: Response): Promise<AttachmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentResponseModel>(null as any);
    }

    /**
     * Create a new attachment
     * @param body (optional) 
     * @return Success
     */
    createUserAttachment(body: UserAttachmentRequestModel | undefined): Promise<AttachmentResponseModel> {
        let url_ = this.baseUrl + "/user-attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUserAttachment(_response);
        });
    }

    protected processCreateUserAttachment(response: Response): Promise<AttachmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentResponseModel>(null as any);
    }

    /**
     * Update attachment
     * @param body (optional) 
     * @return Success
     */
    updateUserAttachment(body: UserAttachmentRequestModel | undefined): Promise<AttachmentResponseModel> {
        let url_ = this.baseUrl + "/user-attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserAttachment(_response);
        });
    }

    protected processUpdateUserAttachment(response: Response): Promise<AttachmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentResponseModel>(null as any);
    }

    /**
     * Delete attachment
     * @param userId (optional) 
     * @return Success
     */
    deleteUserAttachment(userId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/user-attachment?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserAttachment(_response);
        });
    }

    protected processDeleteUserAttachment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Create new user group
     * @param body (optional) 
     * @return Success
     */
    createUserGroup(body: UserGroupRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/user-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUserGroup(_response);
        });
    }

    protected processCreateUserGroup(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update user group
     * @param body (optional) 
     * @return Success
     */
    updateUserGroup(body: UserGroupUpdateRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/user-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserGroup(_response);
        });
    }

    protected processUpdateUserGroup(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get user group list by space Id
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getUserGroupListBySpaceId(spaceId: string, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<UserGroupListResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/user-groups/{spaceId}/list?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGroupListBySpaceId(_response);
        });
    }

    protected processGetUserGroupListBySpaceId(response: Response): Promise<UserGroupListResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroupListResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupListResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get user group list by space Id and visibility by folder id
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getUserGroupListBySpaceIdAndVisibilityByFolderId(spaceId: string, folderId: string, pageSize: number | undefined, pageNumber: number | undefined): Promise<UserGroupListResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/user-groups/{spaceId}/folders/{folderId}/list?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGroupListBySpaceIdAndVisibilityByFolderId(_response);
        });
    }

    protected processGetUserGroupListBySpaceIdAndVisibilityByFolderId(response: Response): Promise<UserGroupListResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroupListResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupListResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Get user group by id
     * @return Success
     */
    getUserGroupById(userGroupId: string): Promise<UserGroupDetailsResponseModel> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserGroupById(_response);
        });
    }

    protected processGetUserGroupById(response: Response): Promise<UserGroupDetailsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroupDetailsResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupDetailsResponseModel>(null as any);
    }

    /**
     * Delete user group
     * @return Success
     */
    deleteUserGroup(userGroupId: string): Promise<string> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserGroup(_response);
        });
    }

    protected processDeleteUserGroup(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Add user to user group
     * @param body (optional) 
     * @return Success
     */
    addUserToUserGroup(userGroupId: string, body: UserGroupUserRequestModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUserToUserGroup(_response);
        });
    }

    protected processAddUserToUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get user list from user group by group id
     * @param name (optional) 
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getUserListFromUserGroupByGroupId(userGroupId: string, name: string | undefined, pageSize: number | undefined, pageNumber: number | undefined): Promise<UserGroupUserResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users?";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserListFromUserGroupByGroupId(_response);
        });
    }

    protected processGetUserListFromUserGroupByGroupId(response: Response): Promise<UserGroupUserResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroupUserResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupUserResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Add folder to user group
     * @param body (optional) 
     * @return Success
     */
    addFolderToUserGroup(userGroupId: string, body: UserGroupFolderRequestModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/folders";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddFolderToUserGroup(_response);
        });
    }

    protected processAddFolderToUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Add user list to user group
     * @param body (optional) 
     * @return Success
     */
    addUserListToUserGroup(userGroupId: string, body: UserGroupUserRequestModel[] | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users/list";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUserListToUserGroup(_response);
        });
    }

    protected processAddUserListToUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Delete user list from user group
     * @param body (optional) 
     * @return Success
     */
    deleteUserListFromUserGroup(userGroupId: string, body: UserGroupUserRequestModel[] | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users/list";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserListFromUserGroup(_response);
        });
    }

    protected processDeleteUserListFromUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Delete user from user group
     * @return Success
     */
    deleteUserFromUserGroup(userGroupId: string, userId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/users/{userId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserFromUserGroup(_response);
        });
    }

    protected processDeleteUserFromUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Delete folder from user group
     * @return Success
     */
    deleteFolderFromUserGroup(userGroupId: string, folderId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/folders/{folderId}";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFolderFromUserGroup(_response);
        });
    }

    protected processDeleteFolderFromUserGroup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get user list from user group by group id and folder id
     * @return Success
     */
    getUserListFromUserGroupByGroupIdAndFolderId(userGroupId: string, folderId: string): Promise<UserGroupUserResponseModel[]> {
        let url_ = this.baseUrl + "/user-groups/{userGroupId}/folders/{folderId}/users";
        if (userGroupId === undefined || userGroupId === null)
            throw new Error("The parameter 'userGroupId' must be defined.");
        url_ = url_.replace("{userGroupId}", encodeURIComponent("" + userGroupId));
        if (folderId === undefined || folderId === null)
            throw new Error("The parameter 'folderId' must be defined.");
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserListFromUserGroupByGroupIdAndFolderId(_response);
        });
    }

    protected processGetUserListFromUserGroupByGroupIdAndFolderId(response: Response): Promise<UserGroupUserResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroupUserResponseModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupUserResponseModel[]>(null as any);
    }

    /**
     * Invite new users
     * @param body (optional) 
     */
    inviteNewUsers(body: InviteUserListRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/user-managers/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteNewUsers(_response);
        });
    }

    protected processInviteNewUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Check Exisiting Invites
     * @param emails (optional) 
     * @param spaceId (optional) 
     */
    checkExistingInvites(emails: string[] | undefined, spaceId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/user-managers/invite/exists?";
        if (emails === null)
            throw new Error("The parameter 'emails' cannot be null.");
        else if (emails !== undefined)
            emails && emails.forEach(item => { url_ += "emails=" + encodeURIComponent("" + item) + "&"; });
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckExistingInvites(_response);
        });
    }

    protected processCheckExistingInvites(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Send confirmation invite again
     * @return Success
     */
    inviteUserAgain(inviteId: string): Promise<void> {
        let url_ = this.baseUrl + "/user-managers/invite/{inviteId}/link/send-again";
        if (inviteId === undefined || inviteId === null)
            throw new Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{inviteId}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteUserAgain(_response);
        });
    }

    protected processInviteUserAgain(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Confirm invite
     * @param body (optional) 
     * @return Success
     */
    confirmInvite(body: ConfirmInviteRequestModel | undefined): Promise<string> {
        let url_ = this.baseUrl + "/user-managers/invite/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmInvite(_response);
        });
    }

    protected processConfirmInvite(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get user space invite status
     * @param pageSize (optional) 
     * @param pageNumber (optional) 
     * @return Success
     */
    getInvitationList(spaceId: string, pageSize: number | undefined, pageNumber: number | undefined): Promise<UserSpaceInvitationResponseModelPagedResponseModel> {
        let url_ = this.baseUrl + "/user-managers/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvitationList(_response);
        });
    }

    protected processGetInvitationList(response: Response): Promise<UserSpaceInvitationResponseModelPagedResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSpaceInvitationResponseModelPagedResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSpaceInvitationResponseModelPagedResponseModel>(null as any);
    }

    /**
     * Remove user from space
     * @param body (optional) 
     * @return Success
     */
    deleteUserFromSpace(body: RemoveUserFromSpaceRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/user-managers/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserFromSpace(_response);
        });
    }

    protected processDeleteUserFromSpace(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get user space role
     * @return Success
     */
    getSpaceRole(spaceId: string): Promise<SpaceRoleResponseModel> {
        let url_ = this.baseUrl + "/user-managers/space-role/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSpaceRole(_response);
        });
    }

    protected processGetSpaceRole(response: Response): Promise<SpaceRoleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaceRoleResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceRoleResponseModel>(null as any);
    }

    /**
     * Get roles to invite
     * @return Success
     */
    getRolesToInvite(): Promise<SpaceRoleResponseModel[]> {
        let url_ = this.baseUrl + "/user-managers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRolesToInvite(_response);
        });
    }

    protected processGetRolesToInvite(response: Response): Promise<SpaceRoleResponseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SpaceRoleResponseModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceRoleResponseModel[]>(null as any);
    }

    /**
     * Check on available members to invite
     * @return Success
     */
    checkInviteRestriction(spaceId: string): Promise<RestrictionResponseModel> {
        let url_ = this.baseUrl + "/user-managers/invite/check/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckInviteRestriction(_response);
        });
    }

    protected processCheckInviteRestriction(response: Response): Promise<RestrictionResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RestrictionResponseModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestrictionResponseModel>(null as any);
    }

    /**
     * Generate 2FA code by user id
     * @param twoFaType (optional) 
     * @return Success
     */
    generate2FACodeByUserId(twoFaType: TwoFATypeEnum | undefined): Promise<TwoFAResponseModel> {
        let url_ = this.baseUrl + "/user-2fa/twofa-code?";
        if (twoFaType === null)
            throw new Error("The parameter 'twoFaType' cannot be null.");
        else if (twoFaType !== undefined)
            url_ += "twoFaType=" + encodeURIComponent("" + twoFaType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerate2FACodeByUserId(_response);
        });
    }

    protected processGenerate2FACodeByUserId(response: Response): Promise<TwoFAResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TwoFAResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TwoFAResponseModel>(null as any);
    }

    /**
     * Generate 2FA code by last code id
     * @return Success
     */
    generate2FACodeByLastCodeId(lastCodeId: string): Promise<TwoFACheckResponseModel> {
        let url_ = this.baseUrl + "/user-2fa/twofa-code/{lastCodeId}";
        if (lastCodeId === undefined || lastCodeId === null)
            throw new Error("The parameter 'lastCodeId' must be defined.");
        url_ = url_.replace("{lastCodeId}", encodeURIComponent("" + lastCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerate2FACodeByLastCodeId(_response);
        });
    }

    protected processGenerate2FACodeByLastCodeId(response: Response): Promise<TwoFACheckResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TwoFACheckResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TwoFACheckResponseModel>(null as any);
    }

    /**
     * Enable 2FA, if code is right
     * @param body (optional) 
     * @return Success
     */
    enable2FA(body: TwoFARequestModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/user-2fa/enable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnable2FA(_response);
        });
    }

    protected processEnable2FA(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Disable 2FA
     * @return Success
     */
    disable2FA(): Promise<boolean> {
        let url_ = this.baseUrl + "/user-2fa/disable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDisable2FA(_response);
        });
    }

    protected processDisable2FA(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get incoming sms
     * @param messageSid (optional) 
     * @param messageStatus (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param optOutType (optional) 
     * @param optInType (optional) 
     * @return Success
     */
    getIncomingSms(messageSid: string | undefined, messageStatus: string | undefined, from: string | undefined, to: string | undefined, optOutType: string | undefined, optInType: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/webhook/twilio-sms-incoming";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (messageSid === null || messageSid === undefined)
            throw new Error("The parameter 'messageSid' cannot be null.");
        else
            content_.append("MessageSid", messageSid.toString());
        if (messageStatus === null || messageStatus === undefined)
            throw new Error("The parameter 'messageStatus' cannot be null.");
        else
            content_.append("MessageStatus", messageStatus.toString());
        if (from === null || from === undefined)
            throw new Error("The parameter 'from' cannot be null.");
        else
            content_.append("From", from.toString());
        if (to === null || to === undefined)
            throw new Error("The parameter 'to' cannot be null.");
        else
            content_.append("To", to.toString());
        if (optOutType === null || optOutType === undefined)
            throw new Error("The parameter 'optOutType' cannot be null.");
        else
            content_.append("OptOutType", optOutType.toString());
        if (optInType === null || optInType === undefined)
            throw new Error("The parameter 'optInType' cannot be null.");
        else
            content_.append("OptInType", optInType.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIncomingSms(_response);
        });
    }

    protected processGetIncomingSms(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ActivateAccountRequestModel {
    userId?: string;
    activationCode?: string;
}

export interface ActiveUserResponseModel {
    id?: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface AdminPaymentHistoryResponseModel {
    invoiceId?: string | undefined;
    invoiceNumber?: string | undefined;
    billingDate?: Date;
    totalAmount?: number;
    status?: string | undefined;
    invoiceUrl?: string | undefined;
    spaceName?: string | undefined;
    spaceId?: string;
    stripeCustomerId?: string | undefined;
}

export interface AdminPaymentHistoryResponseModelStripePagedList {
    nextPage?: string | undefined;
    details?: AdminPaymentHistoryResponseModel[] | undefined;
}

export interface AdminPreSetupPTTemplateCardResponseModel {
    isVisible?: boolean;
    id?: string;
    name?: string | undefined;
    categoryId?: IndustriesEnum;
}

export interface AdminPreSetupPTTemplateCardResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: AdminPreSetupPTTemplateCardResponseModel[] | undefined;
}

export interface AdminPreSetupPTTemplateDetailsResponseModel {
    isVisible?: boolean;
    id?: string;
    name?: string | undefined;
    categoryId?: IndustriesEnum;
    stages?: PTStageTemplateResponseModel[] | undefined;
}

export interface AdminProgressTrackerDetailedResponseModel {
    trackerOwner?: string | undefined;
    userId?: string;
    /** The GUID identifier of the tracker */
    id?: string;
    /** The string name of the object */
    name?: string | undefined;
    /** Date when the object was created */
    createdDate?: Date;
    /** Date when the object was updated last time */
    updatedDate?: Date;
    /** The GUID identifier of the project */
    folderId?: string | undefined;
    /** The full name of the project */
    folderName?: string | undefined;
    /** Tracker completion percentage */
    completenessStatus?: number;
    /** Stages of the tracker */
    stages?: PTStageResponseModel[] | undefined;
    /** Nearest due date among the uncompleted stages in the tracker */
    stageDueDate?: Date | undefined;
    /** The GUID identifier of the space, where the object stored */
    spaceId?: string;
    /** Is Tracker archived */
    isArchived?: boolean;
    isDeleted?: boolean;
    deletedDate?: Date | undefined;
    spaceLogoUrl?: string | undefined;
    trackerId?: string | undefined;
}

export interface AdminProgressTrackerHistoryResponseModel {
    id?: string;
    trackerId?: string;
    updatedById?: string;
    updatedByName?: string | undefined;
    details?: ProgressTrackerHistoryDataViewModel;
    createdDate?: Date;
    type?: ProgressTrackerChangeTypeEnum;
}

export interface AdminProgressTrackerHistoryResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: AdminProgressTrackerHistoryResponseModel[] | undefined;
}

export interface AdminProgressTrackerResponseModel {
    id?: string;
    name?: string | undefined;
    folderName?: string | undefined;
    createdDate?: Date;
    projectOwner?: string | undefined;
    completenessStatus?: number;
    uncompletedStageTotalCount?: number;
    trackerId?: string | undefined;
    isAnyStageEnded?: boolean;
}

export interface AdminProgressTrackerResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: AdminProgressTrackerResponseModel[] | undefined;
}

export interface AdminSpaceResponseModel {
    spaceId?: string;
    spaceName?: string | undefined;
    userTotalCount?: number;
    folderTotalCount?: number;
    progressTrackerTotalCount?: number;
}

export interface AdminSpaceResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: AdminSpaceResponseModel[] | undefined;
}

export interface AdminUserInfoResponseModel {
    id?: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    spaceName?: string | undefined;
    spaceId?: string | undefined;
    createdDate?: Date;
    subscriptionType?: SubscriptionTypeEnum;
    subscriptionName?: string | undefined;
    subscriptionStatus?: string | undefined;
    nextPaymentDate?: Date | undefined;
    spaces?: SpaceResponseModel[] | undefined;
    lifetimeSpend?: number;
    numberOfCreatedProjects?: number | undefined;
    numberOfCreatedTrackers?: number | undefined;
    spaceLogoUrl?: string | undefined;
    lastLoginDate?: Date | undefined;
    numberOfCreatedTemplates?: number | undefined;
    numberOfInvitedUsers?: number | undefined;
}

export interface AgreementRequestModel {
    id?: string;
}

export interface AgreementResponseModel {
    id?: string;
    name?: string | undefined;
    agreementType?: AgreementTypeEnum;
    agreementHtml?: string | undefined;
}

export enum AgreementTypeEnum {
    MasterTerms = 1,
    PrivacyPolicy = 2,
    Eula = 3,
}

export interface AnalyticsMessageHistoryResponseModel {
    id?: string | undefined;
    projectName?: string | undefined;
    trackerName?: string | undefined;
    messageSubject?: string | undefined;
    createdDate?: Date;
    recipient?: string | undefined;
    messageStatus?: MessageStatusEnum;
    messageType?: MessageTypeEnum;
}

export interface AnalyticsMessageHistoryResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: AnalyticsMessageHistoryResponseModel[] | undefined;
}

export interface ArchivedProgressTrackerCardModel {
    id?: string;
    name?: string | undefined;
    percentageCompleteness?: number;
    folderId?: string | undefined;
    folderName?: string | undefined;
    createdDate?: Date;
    trackerId?: string | undefined;
    isAnyStageEnded?: boolean;
}

export interface ArchivedProgressTrackerCardResponseModel {
    spaceName?: string | undefined;
    spaceId?: string | undefined;
    pageNumber?: number;
    totalCount?: number;
    details?: ArchivedProgressTrackerCardModel[] | undefined;
}

export interface AttachmentCreateRequestModel {
    fileName?: string | undefined;
    fileExtension?: string | undefined;
}

export interface AttachmentEditRequestModel {
    getFileUrl?: string | undefined;
    id?: string;
    fileName?: string | undefined;
    s3Key?: string | undefined;
}

export interface AttachmentRequestModel {
    id?: string;
    fileName?: string | undefined;
    s3Key?: string | undefined;
}

export interface AttachmentResponseModel {
    getFileUrl?: string | undefined;
    putFileUrl?: string | undefined;
    contentType?: string | undefined;
    id?: string;
    fileName?: string | undefined;
    s3Key?: string | undefined;
}

export enum BillingCycleEnum {
    Monthly = 1,
    Annual = 2,
}

export interface CancellationReasonResponseModel {
    id?: number;
    reason?: string | undefined;
}

export enum CompanySizeEnum {
    From1to49 = 1,
    From50to99 = 2,
    From100to499 = 3,
    From5to999 = 4,
    From1000to4999 = 5,
    Over5000 = 6,
    From0To100 = 7,
    From101To1000 = 8,
    From1000 = 9,
}

export enum CompletenessFilterEnum {
    Equal0 = 0,
    EqualOrLesser20 = 21,
    EqualOrLesser40 = 41,
    EqualOrLesser60 = 61,
    EqualOrLesser80 = 81,
    Equal100 = 100,
    All = -1,
}

export interface ConfirmInviteRequestModel {
    inviteId?: string;
}

export interface CountryModel {
    id?: string | undefined;
    name?: string | undefined;
}

export interface CreateCommentRequestModel {
    userId?: string;
    comment?: string | undefined;
    createdDate?: Date;
}

export interface CreateUserCommentRequestModel {
    comment?: string | undefined;
}

export interface EditOnboardingRequestModel {
    isProjectPageChecked?: boolean;
    isTemplatePageChecked?: boolean;
    isHomePageChecked?: boolean;
    isAnalyticsPageChecked?: boolean;
}

export interface EditOwnershipRequestModel {
    nextOwnerId?: string;
    spaceId?: string;
}

export interface EditUserSpaceRoleRequestModel {
    spaceId?: string;
    userId?: string;
    roleId?: UserSpaceRoleEnum;
}

export interface EmailIgnoreOptionsRequestModel {
    userId?: string;
    ignoreApproveStageEmail?: boolean;
    ignoreUndoStageEmail?: boolean;
    ignorePaymentFailureEmail?: boolean;
    ignorePurchaseSubscriptionEmail?: boolean;
    ignoreDeadlineNotification?: boolean;
}

export interface EmailIgnoreOptionsResponseModel {
    userId?: string;
    ignoreApproveStageEmail?: boolean;
    ignoreUndoStageEmail?: boolean;
    ignorePaymentFailureEmail?: boolean;
    ignorePurchaseSubscriptionEmail?: boolean;
    ignoreDeadlineNotification?: boolean;
}

export interface ErrorBaseModel {
    errorMessage?: string | undefined;
}

/** File type(Terms and Conditions - 1, Tracker creation example - 2) */
export enum FileTypeEnum {
    TermsAndConditions = 1,
    TrackerCreationTemplate = 2,
}

export enum FolderChangeTypeEnum {
    FolderChanged = 1,
    Created = 2,
}

export interface FolderDashboardResponseModel {
    id?: string;
    uncompletedTrackerTotalCount?: number;
    name?: string | undefined;
}

export interface FolderDashboardResponseModelOverviewDashboardResponseModel {
    completenessStatus?: number | undefined;
    details?: FolderDashboardResponseModel[] | undefined;
}

export interface FolderListResponseModel {
    id?: string;
    name?: string | undefined;
    projectOwner?: string | undefined;
    createdDate?: Date;
    progressTrackerTotalCount?: number;
    completenessStatus?: number | undefined;
}

export interface FolderListResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: FolderListResponseModel[] | undefined;
}

export interface FolderRequestModel {
    name?: string | undefined;
    spaceId?: string;
}

export interface FolderResponseModel {
    /** The GUID identifier of the project */
    id?: string;
    /** The string name of the object */
    name?: string | undefined;
    /** Completeness percentage of trackers in the project */
    completenessTotalCount?: number | undefined;
    /** Total count of trackers in the project */
    progressTrackerTotalCount?: number;
}

export interface FolderResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: FolderResponseModel[] | undefined;
}

export enum FolderSortFieldEnum {
    FolderName = 1,
    ProjectOwner = 2,
    CreatedDate = 3,
}

export interface FolderUpdateRequestModel {
    name?: string | undefined;
    folderId?: string;
}

export interface FolderVisibilityPermissionResponseModel {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    hasAccess?: boolean;
    imageGetUrl?: string | undefined;
}

export interface FolderVisibilityPermissionResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: FolderVisibilityPermissionResponseModel[] | undefined;
}

export interface ForgotPasswordRequestModel {
    email?: string | undefined;
}

export enum IndustriesEnum {
    Education = 1,
    Legal = 2,
    ProfessionalServices = 3,
    GovernmentAndPublicSector = 4,
    FinanceAndBanking = 5,
    Healthcare = 6,
    RealEstate = 7,
    ECommerce = 8,
    Manufacturing = 9,
    HumanResources = 10,
    TransportationAndLogistics = 11,
    Insurance = 12,
    InformationTechnology = 13,
    Aviation = 14,
    Staffing = 15,
    Accounting = 16,
    Retail = 17,
    HospitalityAndTourism = 18,
    MediaAndEntertainment = 19,
    NonProfitAndCharity = 20,
    EnergyAndUtilities = 21,
    Consulting = 22,
    Sales = 23,
    MarketingAndAdvertising = 24,
    FoodAndBeverage = 25,
    Agriculture = 26,
    Religion = 27,
    Construction = 28,
    Other = 29,
}

export enum IntentTypeEnum {
    PaymentIntent = 1,
    SetupIntent = 2,
}

export enum InviteStatusEnum {
    Pending = 1,
    Active = 2,
}

export interface InviteUserListRequestModel {
    usersToInvite?: InviteUserRequestModel[] | undefined;
    spaceName?: string | undefined;
    spaceId?: string;
}

export interface InviteUserRequestModel {
    inviteEmail?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleId?: UserSpaceRoleEnum;
}

export interface InviteUserResponseModel {
    email?: string | undefined;
    isRegistered?: boolean;
}

export interface LetsGetYouApdatedRequestModel {
    email?: string | undefined;
    name?: string | undefined;
    message?: string | undefined;
}

export interface LoginRequestModel {
    email?: string | undefined;
    password?: string | undefined;
    ip?: string | undefined;
}

export interface MessageHistoryResponseModel {
    id?: string;
    messageType?: MessageTypeEnum;
    messageSubject?: MessageSubjectEnum;
    spaceId?: string | undefined;
    spaceName?: string | undefined;
    userId?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    trackerId?: string | undefined;
    trackerName?: string | undefined;
    messageStatus?: MessageStatusEnum;
    sender?: string | undefined;
    recipient?: string | undefined;
    errorMessage?: string | undefined;
    externalId?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
}

export interface MessageHistoryResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: MessageHistoryResponseModel[] | undefined;
}

export enum MessageHistorySortFieldEnum {
    ProjectName = 1,
    EmailType = 2,
    Date = 3,
    DeliveryStatus = 4,
}

export enum MessageStatusEnum {
    Sent = 1,
    FailedToSend = 2,
    Delivered = 3,
    Undelivered = 4,
    Bounced = 5,
    Complaints = 6,
    Rejected = 7,
    Opened = 8,
    Clicked = 9,
}

export enum MessageSubjectEnum {
    ResetPassword = 1,
    ForgotPassword = 2,
    ApproveTrackerStage = 3,
    UndoTrackerStage = 4,
    PaymentFailure = 5,
    PurchaseSubscription = 6,
    SendTwoFACode = 7,
    UserToSpaceInvite = 8,
    StageDeadline = 9,
    ConfirmationRegistration = 10,
    LetsGetApdated = 11,
    UpgradeToEnterprise = 12,
    EnableTwoFA = 13,
    DisableTwoFA = 14,
    CardExpiration = 15,
    EndTrackerStage = 16,
}

export enum MessageTypeEnum {
    Sms = 1,
    Email = 2,
}

export interface MoveProgressTrackerToFolderRequestModel {
    progressTrackerId?: string;
    folderId?: string;
}

export interface NotificationResponseModel {
    id?: number;
    type?: NotificationTypeEnum;
    isNew?: boolean;
    createdDate?: Date;
    details?: any | undefined;
    spaceId?: string;
}

export enum NotificationTypeEnum {
    DailyDeadlineNotification = 1,
}

export interface NotifyDetailsDailyDeadlineModel {
    progressTrackerId?: string;
    progressTrackerName?: string | undefined;
    stageName?: string | undefined;
}

export interface OnboardingPagesResponseModel {
    isProjectPageChecked?: boolean;
    isTemplatePageChecked?: boolean;
    isHomePageChecked?: boolean;
    isAnalyticsPageChecked?: boolean;
}

export interface PTStageEditRequestModel {
    id?: string | undefined;
    status?: StageStatusEnum;
    attachments?: AttachmentEditRequestModel[] | undefined;
    /** The string name of the object */
    name?: string | undefined;
    /** The description of the object */
    description?: string | undefined;
    /** Sequence number of the stage in the tracker */
    sequence: number;
    /** Due date of the stage in the tracker */
    dueDate?: Date | undefined;
}

export interface PTStageRequestModel {
    attachments?: AttachmentRequestModel[] | undefined;
    /** The string name of the object */
    name?: string | undefined;
    /** The description of the object */
    description?: string | undefined;
    /** Sequence number of the stage in the tracker */
    sequence: number;
    /** Due date of the stage in the tracker */
    dueDate?: Date | undefined;
}

export interface PTStageResponseModel {
    /** The GUID identifier of the object */
    id?: string;
    status?: StageStatusEnum;
    /** Stage completion percentage */
    completenessStatus?: number;
    attachments?: AttachmentResponseModel[] | undefined;
    /** The string name of the object */
    name?: string | undefined;
    /** The description of the object */
    description?: string | undefined;
    /** Sequence number of the stage in the tracker */
    sequence: number;
    /** Due date of the stage in the tracker */
    dueDate?: Date | undefined;
}

export interface PTStageTemplateEditRequestModel {
    id?: string | undefined;
    /** The string name of the object */
    name?: string | undefined;
    /** The description of the object */
    description?: string | undefined;
    /** Sequence number of the stage in the tracker */
    sequence: number;
    /** Due date of the stage in the tracker */
    dueDate?: Date | undefined;
}

export interface PTStageTemplateResponseModel {
    id?: string;
    /** The string name of the object */
    name?: string | undefined;
    /** The description of the object */
    description?: string | undefined;
    /** Sequence number of the stage in the tracker */
    sequence: number;
    /** Due date of the stage in the tracker */
    dueDate?: Date | undefined;
}

export interface PaymentHistoryResponseModel {
    invoiceId?: string | undefined;
    invoiceNumber?: string | undefined;
    billingDate?: Date;
    totalAmount?: number;
    status?: string | undefined;
    invoiceUrl?: string | undefined;
}

export interface PaymentHistoryResponseModelStripePagedList {
    nextPage?: string | undefined;
    details?: PaymentHistoryResponseModel[] | undefined;
}

export interface PaymentIntentResponseModel {
    clientSecret?: string | undefined;
    paymentIntentId?: string | undefined;
}

export interface PaymentMethodResponseModel {
    id?: string | undefined;
    brand?: string | undefined;
    customerName?: string | undefined;
    expireMonth?: number;
    expireYear?: number;
    last4?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    fingerPrint?: string | undefined;
}

export interface PaymentResponseModel {
    subscriptionId?: string | undefined;
    clientSecret?: string | undefined;
    intentType?: IntentTypeEnum;
    errorMessage?: string | undefined;
    sumDescription?: SubscriptionSumDescriptionResponseModel;
}

export interface PreSetupPTTemplateCardResponseModel {
    id?: string;
    name?: string | undefined;
    categoryId?: IndustriesEnum;
}

export interface PreSetupPTTemplateCardResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: PreSetupPTTemplateCardResponseModel[] | undefined;
}

export interface PreSetupPTTemplateDetailsResponseModel {
    id?: string;
    name?: string | undefined;
    categoryId?: IndustriesEnum;
    stages?: PTStageTemplateResponseModel[] | undefined;
}

export interface PreSetupTemplateEditRequestModel {
    id?: string;
    isVisible?: boolean;
    category?: IndustriesEnum;
    stages?: PTStageRequestModel[] | undefined;
    name?: string | undefined;
}

export interface PreSetupTemplateRequestModel {
    isVisible?: boolean;
    category?: IndustriesEnum;
    stages?: PTStageRequestModel[] | undefined;
    name?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ProgressTrackerBaseModel {
    name?: string | undefined;
    folderId?: string;
    stages?: PTStageRequestModel[] | undefined;
}

export interface ProgressTrackerCardModel {
    id?: string;
    name?: string | undefined;
    percentageCompleteness?: number;
    stageDueDate?: Date | undefined;
    uncompletedStageTotalCount?: number;
    createdDate?: Date;
    trackerId?: string | undefined;
    isAnyStageEnded?: boolean;
}

export interface ProgressTrackerCardResponseModel {
    folderId?: string | undefined;
    folderName?: string | undefined;
    spaceId?: string | undefined;
    progressTrackerTemplateId?: string | undefined;
    pageNumber?: number;
    totalCount?: number;
    details?: ProgressTrackerCardModel[] | undefined;
}

export enum ProgressTrackerChangeTypeEnum {
    TrackerChanged = 1,
    Archived = 2,
    Unarchived = 3,
    MarkedForDelete = 4,
    Restored = 5,
    Created = 6,
}

export interface ProgressTrackerCommentResponseModel {
    id?: string;
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    progressTrackerId?: string;
    comment?: string | undefined;
    createdDate?: Date;
}

export interface ProgressTrackerCommentResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: ProgressTrackerCommentResponseModel[] | undefined;
}

export interface ProgressTrackerCreateFromFileResponseModel {
    countCreated?: number;
    totalCount?: number;
    processedLines?: number[] | undefined;
    errors?: TrackerCsvErrorModel[] | undefined;
}

export interface ProgressTrackerEditRequestModel {
    id?: string;
    folderId?: string;
    name?: string | undefined;
    stages?: PTStageEditRequestModel[] | undefined;
}

export interface ProgressTrackerHistoryDataViewModel {
    oldData?: ProgressTrackerHistoryDetailsViewModel;
    newData?: ProgressTrackerHistoryDetailsViewModel;
}

export interface ProgressTrackerHistoryDetailsViewModel {
    id?: string;
    name?: string | undefined;
    folderId?: string;
    folderName?: string | undefined;
    stages?: PTStageEditRequestModel[] | undefined;
}

export interface ProgressTrackerHistoryResponseModel {
    id?: string;
    trackerId?: string;
    updatedById?: string;
    updatedByName?: string | undefined;
    details?: ProgressTrackerHistoryDataViewModel;
    createdDate?: Date;
    type?: ProgressTrackerChangeTypeEnum;
}

export interface ProgressTrackerHistoryResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: ProgressTrackerHistoryResponseModel[] | undefined;
}

export enum ProgressTrackerHistorySortFieldEnum {
    CreatedDate = 1,
}

export interface ProgressTrackerListRequestModel {
    progressTrackerTemplateId?: string;
    progressTrackers?: ProgressTrackerBaseModel[] | undefined;
    spaceId?: string;
    isPreSetup?: boolean;
}

export interface ProgressTrackerMobileResponseModel {
    id?: string;
    name?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    completenessStatus?: number;
    stages?: PTStageResponseModel[] | undefined;
    folderId?: string | undefined;
    folderName?: string | undefined;
    spaceId?: string | undefined;
    spaceName?: string | undefined;
    isOwner?: boolean;
    isSubscriber?: boolean;
    isArchived?: boolean;
}

export interface ProgressTrackerRequestModel {
    spaceId?: string;
    templateId?: string | undefined;
    name?: string | undefined;
    folderId?: string;
    stages?: PTStageRequestModel[] | undefined;
}

export interface ProgressTrackerResponseModel {
    /** The GUID identifier of the tracker */
    id?: string;
    /** The string name of the object */
    name?: string | undefined;
    /** Date when the object was created */
    createdDate?: Date;
    /** Date when the object was updated last time */
    updatedDate?: Date;
    /** The GUID identifier of the project */
    folderId?: string | undefined;
    /** The full name of the project */
    folderName?: string | undefined;
    /** Tracker completion percentage */
    completenessStatus?: number;
    /** Stages of the tracker */
    stages?: PTStageResponseModel[] | undefined;
    /** Nearest due date among the uncompleted stages in the tracker */
    stageDueDate?: Date | undefined;
    /** The GUID identifier of the space, where the object stored */
    spaceId?: string;
    /** Is Tracker archived */
    isArchived?: boolean;
    isDeleted?: boolean;
    deletedDate?: Date | undefined;
    spaceLogoUrl?: string | undefined;
    trackerId?: string | undefined;
}

export interface ProgressTrackerSearchResponseModel {
    id?: string;
    name?: string | undefined;
    isSubscriber?: boolean;
    isOwner?: boolean;
    spaceName?: string | undefined;
    percentageCompleteness?: number;
}

export interface ProgressTrackerSearchResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: ProgressTrackerSearchResponseModel[] | undefined;
}

export enum ProgressTrackerSortFieldEnum {
    ProgressTrackerName = 1,
    FolderName = 2,
    ProjectOwner = 3,
}

export interface ProgressTrackerSubscriberResponseModel {
    id?: string;
    progressTrackerId?: string;
    type?: SubscribeTypeEnum;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    subscribedAt?: Date | undefined;
}

export interface ProgressTrackerSubscriberResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: ProgressTrackerSubscriberResponseModel[] | undefined;
}

export interface ProgressTrackerTemplateCardResponseModel {
    id?: string;
    name?: string | undefined;
    usedTimes?: number;
    folderId?: string | undefined;
    folderName?: string | undefined;
}

export interface ProgressTrackerTemplateCardResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: ProgressTrackerTemplateCardResponseModel[] | undefined;
}

export interface ProgressTrackerTemplateEditRequestModel {
    id?: string;
    folderId?: string;
    stages?: PTStageTemplateEditRequestModel[] | undefined;
    isDraft?: boolean;
    name?: string | undefined;
}

export interface ProgressTrackerTemplateRequestModel {
    stages?: PTStageRequestModel[] | undefined;
    spaceId?: string;
    folderId?: string;
    isDraft?: boolean;
    name?: string | undefined;
}

export interface ProgressTrackerTemplateResponseModel {
    id?: string;
    name?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    usedTimes?: number;
    stages?: PTStageTemplateResponseModel[] | undefined;
    spaceId?: string;
    folderId?: string | undefined;
    folderName?: string | undefined;
    isDraft?: boolean;
}

export interface PromotionCodeResponseModel {
    discountPercent?: number | undefined;
    discountSum?: number;
}

export interface RefreshTokenRequestModel {
    accessToken?: string | undefined;
}

export interface RegistrationRequestModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    inviteId?: string | undefined;
    minsTimeOffset?: number;
}

export interface RemoveUserFromSpaceRequestModel {
    userInviteId?: string;
    spaceId?: string;
}

export interface ResetPasswordRequestModel {
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
}

export interface RestorePasswordRequestModel {
    password?: string | undefined;
    userId?: string;
    code?: string;
}

export interface RestrictionResponseModel {
    isCanCreate?: boolean;
    availableCountToCreate?: number | undefined;
}

export enum RestrictionTypeEnum {
    OneTime = 1,
    Monthly = 2,
}

export interface S3DownloadResponseModel {
    fileName?: string | undefined;
    downloadUrl?: string | undefined;
}

export interface SendConfirmationRegistrationRequestModel {
    email?: string | undefined;
}

export interface SetStatusRequestModel {
    status?: StageStatusEnum;
}

export enum SortFieldEnum {
    Name = 1,
    Date = 2,
    CompletenessStatus = 3,
}

export enum SortOrderEnum {
    Asc = 0,
    Desc = 1,
}

export interface SpaceAnalyticsResponseModel {
    folderCompletenessRatio?: number;
    trackerCompletenessRatio?: number;
    foldersCount?: number;
    trackersCount?: number;
    trackersCompletedCount?: number;
    foldersCompletedCount?: number;
    trackersAvgCompletedPercent?: number;
}

export interface SpaceFolderTrackersCountResponseModel {
    folderId?: string;
    folderName?: string | undefined;
    trackersCount?: number;
}

export interface SpaceFolderTrackersCountResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: SpaceFolderTrackersCountResponseModel[] | undefined;
}

export interface SpaceLastActivityResponseModel {
    userId?: string;
    objectId?: string;
    userName?: string | undefined;
    objectName?: string | undefined;
    trackerChangeType?: ProgressTrackerChangeTypeEnum;
    folderChangeType?: FolderChangeTypeEnum;
    activityDate?: Date;
}

export interface SpaceLastActivityResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: SpaceLastActivityResponseModel[] | undefined;
}

export interface SpaceRequestModel {
    name?: string | undefined;
}

export interface SpaceResponseModel {
    id?: string;
    name?: string | undefined;
}

export interface SpaceRoleResponseModel {
    roleId?: UserSpaceRoleEnum;
    roleName?: string | undefined;
}

export enum SpaceSortFieldEnum {
    SpaceName = 1,
}

export interface SpaceSubdomainRequestModel {
    spaceId?: string;
    subdomain?: string | undefined;
}

/** Stage status(Pending - 1, Done - 2) */
export enum StageStatusEnum {
    Pending = 1,
    Done = 2,
    End = 3,
}

export enum StripeSubscriptionTypeEnum {
    OneTime = 1,
    Recurring = 2,
}

export interface SubscribeProgressTrackerRequestModel {
    progressTrackerId?: string;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    type?: SubscribeTypeEnum;
}

export enum SubscribeTypeEnum {
    Sms = 1,
    Email = 2,
    Push = 3,
}

export interface SubscribedTrackerResponseModel {
    trackerId?: string;
    trackerName?: string | undefined;
    completnessStatus?: number;
    spaceName?: string | undefined;
}

export interface SubscriptionPriceModel {
    priceId?: string | undefined;
    name?: string | undefined;
    price?: number;
    type?: StripeSubscriptionTypeEnum;
}

export interface SubscriptionRequestModel {
    priceId?: string | undefined;
    promotionCode?: string | undefined;
    spaceId?: string;
    defaultPaymentMethod?: string | undefined;
    isUpgradeRequested?: boolean;
    isInviteRequested?: boolean;
    quantity?: number;
    requestedBillingCycle?: BillingCycleEnum;
}

export interface SubscriptionResponseModel {
    id?: string;
    stripeId?: string | undefined;
    name?: string | undefined;
    type?: SubscriptionTypeEnum;
    prices?: SubscriptionPriceModel[] | undefined;
    memberCount?: number | undefined;
    numberOfProjects?: number | undefined;
    projectsRestrictionType?: RestrictionTypeEnum;
    numberOfTrackers?: number | undefined;
    trackersRestrictionType?: RestrictionTypeEnum;
    isReusableTemplates?: boolean;
    billingCycle?: BillingCycleEnum;
}

export interface SubscriptionSumDescriptionResponseModel {
    subtotal?: number | undefined;
    totalSum?: number;
    taxSum?: number | undefined;
    promotionCode?: PromotionCodeResponseModel;
}

export enum SubscriptionTypeEnum {
    Basic = 1,
    Standard = 2,
    Advanced = 3,
    Enterprise = 4,
    TeammateInvite = 5,
}

export enum TimeZoneEnum {
    UTC_Minus_12 = 1,
    UTC_Minus_11 = 2,
    UTC_Minus_10 = 3,
    UTC_Minus_09 = 4,
    UTC_Minus_08 = 5,
    UTC_Minus_07 = 6,
    UTC_Minus_06 = 7,
    UTC_Minus_05 = 8,
    UTC_Minus_04 = 9,
    UTC_Minus_03_30 = 10,
    UTC_Minus_03 = 11,
    UTC_Minus_02 = 12,
    UTC_Minus_01 = 13,
    UTC_00 = 14,
    UTC_Plus_01 = 15,
    UTC_Plus_02 = 16,
    UTC_Plus_03 = 17,
    UTC_Plus_03_30 = 18,
    UTC_Plus_04 = 19,
    UTC_Plus_04_30 = 20,
    UTC_Plus_05 = 21,
    UTC_Plus_05_30 = 22,
    UTC_Plus_05_45 = 23,
    UTC_Plus_06 = 24,
    UTC_Plus_06_30 = 25,
    UTC_Plus_07 = 26,
    UTC_Plus_08 = 27,
    UTC_Plus_09 = 28,
    UTC_Plus_09_30 = 29,
    UTC_Plus_10 = 30,
    UTC_Plus_10_30 = 31,
    UTC_Plus_11 = 32,
    UTC_Plus_12 = 33,
    UTC_Plus_12_45 = 34,
    UTC_Plus_13 = 35,
    UTC_Plus_14 = 36,
}

export interface TokenResponseModel {
    token?: string | undefined;
    expireDate?: Date;
    twoFAModel?: TwoFACheckResponseModel;
}

export interface TrackerCsvErrorModel {
    lineNumber?: number;
    errors?: ErrorBaseModel[] | undefined;
    skipLine?: boolean;
}

export interface TrackerDashboardResponseModel {
    id?: string;
    name?: string | undefined;
    uncompletedStageTotalCount?: number | undefined;
}

export interface TrackerDashboardResponseModelOverviewDashboardResponseModel {
    completenessStatus?: number | undefined;
    details?: TrackerDashboardResponseModel[] | undefined;
}

export interface TrackerSubscribeRequestModel {
    trackerId?: string;
}

export interface TrackerUnsubscribeRequestModel {
    trackerId?: string;
}

export interface TwoFACheckResponseModel {
    codeId?: string | undefined;
    userId?: string;
    expireDate?: Date;
    twoFaType?: TwoFATypeEnum;
}

export interface TwoFARequestModel {
    codeId?: string | undefined;
    userId?: string;
    code?: string | undefined;
    twoFaType?: TwoFATypeEnum;
    ip?: string | undefined;
}

export interface TwoFAResponseModel {
    setupCode?: string | undefined;
    imgQrCodeUrl?: string | undefined;
    codeId?: string | undefined;
    userId?: string;
    expireDate?: Date;
    twoFaType?: TwoFATypeEnum;
}

export enum TwoFATypeEnum {
    Email = 1,
    Authenticator = 2,
}

export interface UpgradeToEnterpriseRequestModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    businessEmail?: string | undefined;
    companySize?: CompanySizeEnum;
}

export interface UserAttachmentRequestModel {
    userId?: string;
    attachment?: AttachmentCreateRequestModel;
}

export interface UserCancellationReasonResponseModel {
    userId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    subscriptionName?: string | undefined;
    spaceName?: string | undefined;
    actualCancellationDate?: Date;
    requestedDate?: Date;
    reason?: string | undefined;
}

export interface UserCancellationReasonResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: UserCancellationReasonResponseModel[] | undefined;
}

export interface UserCommentResponseModel {
    id?: string;
    userId?: string;
    createdUserId?: string;
    comment?: string | undefined;
    createdUserFirstName?: string | undefined;
    createdUserLastName?: string | undefined;
    createdDate?: Date;
}

export interface UserCommentResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: UserCommentResponseModel[] | undefined;
}

export interface UserGroupDetailsResponseModel {
    folders?: UserGroupFolderResponseModel[] | undefined;
    users?: UserGroupUserResponseModel[] | undefined;
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    spaceId?: string;
    createdDate?: Date;
    forUsersWithoutGroups?: boolean;
}

export interface UserGroupFolderRequestModel {
    folderId?: string;
}

export interface UserGroupFolderResponseModel {
    folderId?: string;
    groupId?: string;
    folderName?: string | undefined;
}

export interface UserGroupListResponseModel {
    userCount?: number;
    imageGetUrl?: string[] | undefined;
    isVisible?: boolean;
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    spaceId?: string;
    createdDate?: Date;
    forUsersWithoutGroups?: boolean;
}

export interface UserGroupListResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: UserGroupListResponseModel[] | undefined;
}

export interface UserGroupRequestModel {
    name?: string | undefined;
    description?: string | undefined;
    spaceId?: string;
    users?: UserGroupUserRequestModel[] | undefined;
    folders?: UserGroupFolderRequestModel[] | undefined;
}

export interface UserGroupUpdateRequestModel {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    users?: UserGroupUserRequestModel[] | undefined;
    folders?: UserGroupFolderRequestModel[] | undefined;
}

export interface UserGroupUserRequestModel {
    userId?: string;
}

export interface UserGroupUserResponseModel {
    userId?: string;
    groupId?: string;
    userName?: string | undefined;
    email?: string | undefined;
    imageGetUrl?: string | undefined;
    isFolderVisible?: boolean;
}

export interface UserGroupUserResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: UserGroupUserResponseModel[] | undefined;
}

export interface UserListResponseModel {
    id?: string;
    spaceName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    currentPlan?: string | undefined;
}

export interface UserListResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: UserListResponseModel[] | undefined;
}

export interface UserProfileDetailsEditRequestModel {
    id?: string | undefined;
    companyName?: string | undefined;
    companyWebsiteUrl?: string | undefined;
    companySize?: CompanySizeEnum;
    jobTitle?: string | undefined;
    industry?: IndustriesEnum;
    otherIndustry?: string | undefined;
    countryCodeId?: string | undefined;
    phoneNumber?: string | undefined;
    linkedin?: string | undefined;
    twitter?: string | undefined;
    facebook?: string | undefined;
    instagram?: string | undefined;
    timeZone?: TimeZoneEnum;
    isSmsAllowed?: boolean;
}

export interface UserProfileDetailsResponseModel {
    id?: string | undefined;
    companyName?: string | undefined;
    companyWebsiteUrl?: string | undefined;
    companySize?: CompanySizeEnum;
    jobTitle?: string | undefined;
    industry?: IndustriesEnum;
    otherIndustry?: string | undefined;
    countryCodeId?: string | undefined;
    phoneNumber?: string | undefined;
    linkedin?: string | undefined;
    twitter?: string | undefined;
    facebook?: string | undefined;
    instagram?: string | undefined;
    timeZone?: TimeZoneEnum;
    isSmsAllowed?: boolean;
}

export interface UserResponseModel {
    id?: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isActive?: boolean;
    spaceName?: string | undefined;
    spaceId?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date;
    subscriptionId?: string;
    billingCycle?: BillingCycleEnum;
    isBillingCycleChangeRequested?: boolean;
    subscriptionType?: SubscriptionTypeEnum;
    subscriptionName?: string | undefined;
    nextPaymentDate?: Date | undefined;
    is2FAEnabled?: boolean;
    twoFAType?: TwoFATypeEnum;
    isOwner?: boolean;
    defaultPaymentMethodId?: string | undefined;
    subdomain?: string | undefined;
    onboardingPages?: OnboardingPagesResponseModel;
    emailIgnoreOptions?: EmailIgnoreOptionsResponseModel;
    userProfileDetails?: UserProfileDetailsResponseModel;
    isSubscriptionCanceled?: boolean;
    isSubscriptionTrial?: boolean;
    accountId?: string | undefined;
}

export interface UserSessionResponseModel {
    id?: number;
    createdDate?: Date;
    isActive?: boolean;
    city?: string | undefined;
    country?: string | undefined;
    operationSystem?: string | undefined;
    ipAddress?: string | undefined;
    userAgent?: string | undefined;
}

export interface UserSessionResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: UserSessionResponseModel[] | undefined;
}

export enum UserSortFieldEnum {
    FirstName = 1,
    LastName = 2,
    Email = 3,
    SpaceName = 4,
}

export interface UserSpaceInvitationResponseModel {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: InviteStatusEnum;
    inviteEmail?: string | undefined;
    roleId?: UserSpaceRoleEnum;
    roleName?: string | undefined;
    userId?: string | undefined;
}

export interface UserSpaceInvitationResponseModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: UserSpaceInvitationResponseModel[] | undefined;
}

export enum UserSpaceRoleEnum {
    SuperAdmin = 1,
    Basic = 2,
    Admin = 3,
}

export interface UserUpdateRequestModel {
    id?: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    spaceId?: string;
    subdomain?: string | undefined;
    profileDetailsEditRequest?: UserProfileDetailsEditRequestModel;
}

export interface WidgetModel {
    trackerId?: string;
    trackerName?: string | undefined;
    completnessStatus?: number;
    spaceName?: string | undefined;
    dueDate?: Date | undefined;
}

export interface WidgetModelPagedResponseModel {
    pageNumber?: number;
    totalCount?: number;
    details?: WidgetModel[] | undefined;
}

export interface Body {
    SpaceId?: string;
    File?: string;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}